(() => { var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, {
      get: all[name],
      enumerable: true,
      configurable: true,
      set: (newValue) => all[name] = () => newValue
    });
};

// ../../../../../../tmp/date-fns-jalali/fp.mjs
var exports_fp = {};
__export(exports_fp, {
  yearsToQuarters: () => {
    {
      return yearsToQuarters3;
    }
  },
  yearsToMonths: () => {
    {
      return yearsToMonths3;
    }
  },
  yearsToDays: () => {
    {
      return yearsToDays3;
    }
  },
  weeksToDays: () => {
    {
      return weeksToDays3;
    }
  },
  transpose: () => {
    {
      return transpose4;
    }
  },
  toDate: () => {
    {
      return toDate127;
    }
  },
  subYears: () => {
    {
      return subYears3;
    }
  },
  subWeeks: () => {
    {
      return subWeeks3;
    }
  },
  subSeconds: () => {
    {
      return subSeconds3;
    }
  },
  subQuarters: () => {
    {
      return subQuarters3;
    }
  },
  subMonths: () => {
    {
      return subMonths4;
    }
  },
  subMinutes: () => {
    {
      return subMinutes3;
    }
  },
  subMilliseconds: () => {
    {
      return subMilliseconds3;
    }
  },
  subISOWeekYears: () => {
    {
      return subISOWeekYears4;
    }
  },
  subHours: () => {
    {
      return subHours3;
    }
  },
  subDays: () => {
    {
      return subDays5;
    }
  },
  subBusinessDays: () => {
    {
      return subBusinessDays3;
    }
  },
  sub: () => {
    {
      return sub3;
    }
  },
  startOfYear: () => {
    {
      return startOfYear5;
    }
  },
  startOfWeekYearWithOptions: () => {
    {
      return startOfWeekYearWithOptions;
    }
  },
  startOfWeekYear: () => {
    {
      return startOfWeekYear5;
    }
  },
  startOfWeekWithOptions: () => {
    {
      return startOfWeekWithOptions;
    }
  },
  startOfWeek: () => {
    {
      return startOfWeek12;
    }
  },
  startOfSecond: () => {
    {
      return startOfSecond4;
    }
  },
  startOfQuarter: () => {
    {
      return startOfQuarter5;
    }
  },
  startOfMonth: () => {
    {
      return startOfMonth6;
    }
  },
  startOfMinute: () => {
    {
      return startOfMinute5;
    }
  },
  startOfISOWeekYear: () => {
    {
      return startOfISOWeekYear7;
    }
  },
  startOfISOWeek: () => {
    {
      return startOfISOWeek11;
    }
  },
  startOfHour: () => {
    {
      return startOfHour4;
    }
  },
  startOfDecade: () => {
    {
      return startOfDecade3;
    }
  },
  startOfDay: () => {
    {
      return startOfDay5;
    }
  },
  setYear: () => {
    {
      return setYear3;
    }
  },
  setWeekYearWithOptions: () => {
    {
      return setWeekYearWithOptions;
    }
  },
  setWeekYear: () => {
    {
      return setWeekYear3;
    }
  },
  setWeekWithOptions: () => {
    {
      return setWeekWithOptions;
    }
  },
  setWeek: () => {
    {
      return setWeek4;
    }
  },
  setSeconds: () => {
    {
      return setSeconds3;
    }
  },
  setQuarter: () => {
    {
      return setQuarter3;
    }
  },
  setMonth: () => {
    {
      return setMonth19;
    }
  },
  setMinutes: () => {
    {
      return setMinutes3;
    }
  },
  setMilliseconds: () => {
    {
      return setMilliseconds3;
    }
  },
  setISOWeekYear: () => {
    {
      return setISOWeekYear4;
    }
  },
  setISOWeek: () => {
    {
      return setISOWeek4;
    }
  },
  setISODay: () => {
    {
      return setISODay4;
    }
  },
  setHours: () => {
    {
      return setHours3;
    }
  },
  setDayWithOptions: () => {
    {
      return setDayWithOptions;
    }
  },
  setDayOfYear: () => {
    {
      return setDayOfYear3;
    }
  },
  setDay: () => {
    {
      return setDay6;
    }
  },
  setDate: () => {
    {
      return setDate18;
    }
  },
  set: () => {
    {
      return set3;
    }
  },
  secondsToMinutes: () => {
    {
      return secondsToMinutes3;
    }
  },
  secondsToMilliseconds: () => {
    {
      return secondsToMilliseconds3;
    }
  },
  secondsToHours: () => {
    {
      return secondsToHours3;
    }
  },
  roundToNearestMinutesWithOptions: () => {
    {
      return roundToNearestMinutesWithOptions;
    }
  },
  roundToNearestMinutes: () => {
    {
      return roundToNearestMinutes3;
    }
  },
  roundToNearestHoursWithOptions: () => {
    {
      return roundToNearestHoursWithOptions;
    }
  },
  roundToNearestHours: () => {
    {
      return roundToNearestHours3;
    }
  },
  quartersToYears: () => {
    {
      return quartersToYears3;
    }
  },
  quartersToMonths: () => {
    {
      return quartersToMonths3;
    }
  },
  previousWednesday: () => {
    {
      return previousWednesday3;
    }
  },
  previousTuesday: () => {
    {
      return previousTuesday3;
    }
  },
  previousThursday: () => {
    {
      return previousThursday3;
    }
  },
  previousSunday: () => {
    {
      return previousSunday3;
    }
  },
  previousSaturday: () => {
    {
      return previousSaturday3;
    }
  },
  previousMonday: () => {
    {
      return previousMonday3;
    }
  },
  previousFriday: () => {
    {
      return previousFriday3;
    }
  },
  previousDay: () => {
    {
      return previousDay3;
    }
  },
  parseWithOptions: () => {
    {
      return parseWithOptions;
    }
  },
  parseJSON: () => {
    {
      return parseJSON3;
    }
  },
  parseISOWithOptions: () => {
    {
      return parseISOWithOptions;
    }
  },
  parseISO: () => {
    {
      return parseISO3;
    }
  },
  parse: () => {
    {
      return parse4;
    }
  },
  nextWednesday: () => {
    {
      return nextWednesday3;
    }
  },
  nextTuesday: () => {
    {
      return nextTuesday3;
    }
  },
  nextThursday: () => {
    {
      return nextThursday3;
    }
  },
  nextSunday: () => {
    {
      return nextSunday3;
    }
  },
  nextSaturday: () => {
    {
      return nextSaturday3;
    }
  },
  nextMonday: () => {
    {
      return nextMonday3;
    }
  },
  nextFriday: () => {
    {
      return nextFriday3;
    }
  },
  nextDay: () => {
    {
      return nextDay3;
    }
  },
  monthsToYears: () => {
    {
      return monthsToYears3;
    }
  },
  monthsToQuarters: () => {
    {
      return monthsToQuarters3;
    }
  },
  minutesToSeconds: () => {
    {
      return minutesToSeconds3;
    }
  },
  minutesToMilliseconds: () => {
    {
      return minutesToMilliseconds3;
    }
  },
  minutesToHours: () => {
    {
      return minutesToHours3;
    }
  },
  min: () => {
    {
      return min4;
    }
  },
  millisecondsToSeconds: () => {
    {
      return millisecondsToSeconds3;
    }
  },
  millisecondsToMinutes: () => {
    {
      return millisecondsToMinutes3;
    }
  },
  millisecondsToHours: () => {
    {
      return millisecondsToHours3;
    }
  },
  milliseconds: () => {
    {
      return milliseconds3;
    }
  },
  max: () => {
    {
      return max4;
    }
  },
  lightFormat: () => {
    {
      return lightFormat3;
    }
  },
  lastDayOfYear: () => {
    {
      return lastDayOfYear3;
    }
  },
  lastDayOfWeekWithOptions: () => {
    {
      return lastDayOfWeekWithOptions;
    }
  },
  lastDayOfWeek: () => {
    {
      return lastDayOfWeek4;
    }
  },
  lastDayOfQuarter: () => {
    {
      return lastDayOfQuarter3;
    }
  },
  lastDayOfMonth: () => {
    {
      return lastDayOfMonth4;
    }
  },
  lastDayOfISOWeekYear: () => {
    {
      return lastDayOfISOWeekYear3;
    }
  },
  lastDayOfISOWeek: () => {
    {
      return lastDayOfISOWeek3;
    }
  },
  lastDayOfDecade: () => {
    {
      return lastDayOfDecade3;
    }
  },
  isWithinInterval: () => {
    {
      return isWithinInterval3;
    }
  },
  isWeekend: () => {
    {
      return isWeekend6;
    }
  },
  isWednesday: () => {
    {
      return isWednesday3;
    }
  },
  isValid: () => {
    {
      return isValid9;
    }
  },
  isTuesday: () => {
    {
      return isTuesday3;
    }
  },
  isThursday: () => {
    {
      return isThursday3;
    }
  },
  isSunday: () => {
    {
      return isSunday4;
    }
  },
  isSaturday: () => {
    {
      return isSaturday4;
    }
  },
  isSameYear: () => {
    {
      return isSameYear3;
    }
  },
  isSameWeekWithOptions: () => {
    {
      return isSameWeekWithOptions;
    }
  },
  isSameWeek: () => {
    {
      return isSameWeek4;
    }
  },
  isSameSecond: () => {
    {
      return isSameSecond3;
    }
  },
  isSameQuarter: () => {
    {
      return isSameQuarter3;
    }
  },
  isSameMonth: () => {
    {
      return isSameMonth3;
    }
  },
  isSameMinute: () => {
    {
      return isSameMinute3;
    }
  },
  isSameISOWeekYear: () => {
    {
      return isSameISOWeekYear3;
    }
  },
  isSameISOWeek: () => {
    {
      return isSameISOWeek3;
    }
  },
  isSameHour: () => {
    {
      return isSameHour3;
    }
  },
  isSameDay: () => {
    {
      return isSameDay4;
    }
  },
  isMonday: () => {
    {
      return isMonday3;
    }
  },
  isMatchWithOptions: () => {
    {
      return isMatchWithOptions;
    }
  },
  isMatch: () => {
    {
      return isMatch3;
    }
  },
  isLeapYear: () => {
    {
      return isLeapYear6;
    }
  },
  isLastDayOfMonth: () => {
    {
      return isLastDayOfMonth4;
    }
  },
  isFriday: () => {
    {
      return isFriday3;
    }
  },
  isFirstDayOfMonth: () => {
    {
      return isFirstDayOfMonth3;
    }
  },
  isExists: () => {
    {
      return isExists3;
    }
  },
  isEqual: () => {
    {
      return isEqual3;
    }
  },
  isDate: () => {
    {
      return isDate4;
    }
  },
  isBefore: () => {
    {
      return isBefore3;
    }
  },
  isAfter: () => {
    {
      return isAfter3;
    }
  },
  intlFormatDistanceWithOptions: () => {
    {
      return intlFormatDistanceWithOptions;
    }
  },
  intlFormatDistance: () => {
    {
      return intlFormatDistance3;
    }
  },
  intlFormat: () => {
    {
      return intlFormat3;
    }
  },
  intervalWithOptions: () => {
    {
      return intervalWithOptions;
    }
  },
  intervalToDuration: () => {
    {
      return intervalToDuration3;
    }
  },
  interval: () => {
    {
      return interval3;
    }
  },
  hoursToSeconds: () => {
    {
      return hoursToSeconds3;
    }
  },
  hoursToMinutes: () => {
    {
      return hoursToMinutes3;
    }
  },
  hoursToMilliseconds: () => {
    {
      return hoursToMilliseconds3;
    }
  },
  getYear: () => {
    {
      return getYear3;
    }
  },
  getWeeksInMonthWithOptions: () => {
    {
      return getWeeksInMonthWithOptions;
    }
  },
  getWeeksInMonth: () => {
    {
      return getWeeksInMonth3;
    }
  },
  getWeekYearWithOptions: () => {
    {
      return getWeekYearWithOptions;
    }
  },
  getWeekYear: () => {
    {
      return getWeekYear5;
    }
  },
  getWeekWithOptions: () => {
    {
      return getWeekWithOptions;
    }
  },
  getWeekOfMonthWithOptions: () => {
    {
      return getWeekOfMonthWithOptions;
    }
  },
  getWeekOfMonth: () => {
    {
      return getWeekOfMonth3;
    }
  },
  getWeek: () => {
    {
      return getWeek4;
    }
  },
  getUnixTime: () => {
    {
      return getUnixTime3;
    }
  },
  getTime: () => {
    {
      return getTime3;
    }
  },
  getSeconds: () => {
    {
      return getSeconds3;
    }
  },
  getQuarter: () => {
    {
      return getQuarter4;
    }
  },
  getOverlappingDaysInIntervals: () => {
    {
      return getOverlappingDaysInIntervals3;
    }
  },
  getMonth: () => {
    {
      return getMonth17;
    }
  },
  getMinutes: () => {
    {
      return getMinutes3;
    }
  },
  getMilliseconds: () => {
    {
      return getMilliseconds3;
    }
  },
  getISOWeeksInYear: () => {
    {
      return getISOWeeksInYear3;
    }
  },
  getISOWeekYear: () => {
    {
      return getISOWeekYear8;
    }
  },
  getISOWeek: () => {
    {
      return getISOWeek4;
    }
  },
  getISODay: () => {
    {
      return getISODay3;
    }
  },
  getHours: () => {
    {
      return getHours3;
    }
  },
  getDecade: () => {
    {
      return getDecade3;
    }
  },
  getDaysInYear: () => {
    {
      return getDaysInYear3;
    }
  },
  getDaysInMonth: () => {
    {
      return getDaysInMonth3;
    }
  },
  getDayOfYear: () => {
    {
      return getDayOfYear4;
    }
  },
  getDay: () => {
    {
      return getDay3;
    }
  },
  getDate: () => {
    {
      return getDate15;
    }
  },
  fromUnixTime: () => {
    {
      return fromUnixTime3;
    }
  },
  formatWithOptions: () => {
    {
      return formatWithOptions;
    }
  },
  formatRelativeWithOptions: () => {
    {
      return formatRelativeWithOptions;
    }
  },
  formatRelative: () => {
    {
      return formatRelative5;
    }
  },
  formatRFC7231: () => {
    {
      return formatRFC72313;
    }
  },
  formatRFC3339WithOptions: () => {
    {
      return formatRFC3339WithOptions;
    }
  },
  formatRFC3339: () => {
    {
      return formatRFC33393;
    }
  },
  formatISOWithOptions: () => {
    {
      return formatISOWithOptions;
    }
  },
  formatISODuration: () => {
    {
      return formatISODuration3;
    }
  },
  formatISO9075WithOptions: () => {
    {
      return formatISO9075WithOptions;
    }
  },
  formatISO9075: () => {
    {
      return formatISO90753;
    }
  },
  formatISO: () => {
    {
      return formatISO3;
    }
  },
  formatDurationWithOptions: () => {
    {
      return formatDurationWithOptions;
    }
  },
  formatDuration: () => {
    {
      return formatDuration3;
    }
  },
  formatDistanceWithOptions: () => {
    {
      return formatDistanceWithOptions;
    }
  },
  formatDistanceStrictWithOptions: () => {
    {
      return formatDistanceStrictWithOptions;
    }
  },
  formatDistanceStrict: () => {
    {
      return formatDistanceStrict3;
    }
  },
  formatDistance: () => {
    {
      return formatDistance5;
    }
  },
  format: () => {
    {
      return format3;
    }
  },
  endOfYear: () => {
    {
      return endOfYear4;
    }
  },
  endOfWeekWithOptions: () => {
    {
      return endOfWeekWithOptions;
    }
  },
  endOfWeek: () => {
    {
      return endOfWeek4;
    }
  },
  endOfSecond: () => {
    {
      return endOfSecond3;
    }
  },
  endOfQuarter: () => {
    {
      return endOfQuarter3;
    }
  },
  endOfMonth: () => {
    {
      return endOfMonth5;
    }
  },
  endOfMinute: () => {
    {
      return endOfMinute3;
    }
  },
  endOfISOWeekYear: () => {
    {
      return endOfISOWeekYear3;
    }
  },
  endOfISOWeek: () => {
    {
      return endOfISOWeek3;
    }
  },
  endOfHour: () => {
    {
      return endOfHour3;
    }
  },
  endOfDecade: () => {
    {
      return endOfDecade3;
    }
  },
  endOfDay: () => {
    {
      return endOfDay4;
    }
  },
  eachYearOfIntervalWithOptions: () => {
    {
      return eachYearOfIntervalWithOptions;
    }
  },
  eachYearOfInterval: () => {
    {
      return eachYearOfInterval3;
    }
  },
  eachWeekendOfYear: () => {
    {
      return eachWeekendOfYear3;
    }
  },
  eachWeekendOfMonth: () => {
    {
      return eachWeekendOfMonth3;
    }
  },
  eachWeekendOfInterval: () => {
    {
      return eachWeekendOfInterval3;
    }
  },
  eachWeekOfIntervalWithOptions: () => {
    {
      return eachWeekOfIntervalWithOptions;
    }
  },
  eachWeekOfInterval: () => {
    {
      return eachWeekOfInterval3;
    }
  },
  eachQuarterOfIntervalWithOptions: () => {
    {
      return eachQuarterOfIntervalWithOptions;
    }
  },
  eachQuarterOfInterval: () => {
    {
      return eachQuarterOfInterval3;
    }
  },
  eachMonthOfIntervalWithOptions: () => {
    {
      return eachMonthOfIntervalWithOptions;
    }
  },
  eachMonthOfInterval: () => {
    {
      return eachMonthOfInterval3;
    }
  },
  eachMinuteOfIntervalWithOptions: () => {
    {
      return eachMinuteOfIntervalWithOptions;
    }
  },
  eachMinuteOfInterval: () => {
    {
      return eachMinuteOfInterval3;
    }
  },
  eachHourOfIntervalWithOptions: () => {
    {
      return eachHourOfIntervalWithOptions;
    }
  },
  eachHourOfInterval: () => {
    {
      return eachHourOfInterval3;
    }
  },
  eachDayOfIntervalWithOptions: () => {
    {
      return eachDayOfIntervalWithOptions;
    }
  },
  eachDayOfInterval: () => {
    {
      return eachDayOfInterval3;
    }
  },
  differenceInYears: () => {
    {
      return differenceInYears3;
    }
  },
  differenceInWeeksWithOptions: () => {
    {
      return differenceInWeeksWithOptions;
    }
  },
  differenceInWeeks: () => {
    {
      return differenceInWeeks3;
    }
  },
  differenceInSecondsWithOptions: () => {
    {
      return differenceInSecondsWithOptions;
    }
  },
  differenceInSeconds: () => {
    {
      return differenceInSeconds3;
    }
  },
  differenceInQuartersWithOptions: () => {
    {
      return differenceInQuartersWithOptions;
    }
  },
  differenceInQuarters: () => {
    {
      return differenceInQuarters3;
    }
  },
  differenceInMonths: () => {
    {
      return differenceInMonths3;
    }
  },
  differenceInMinutesWithOptions: () => {
    {
      return differenceInMinutesWithOptions;
    }
  },
  differenceInMinutes: () => {
    {
      return differenceInMinutes3;
    }
  },
  differenceInMilliseconds: () => {
    {
      return differenceInMilliseconds4;
    }
  },
  differenceInISOWeekYears: () => {
    {
      return differenceInISOWeekYears3;
    }
  },
  differenceInHoursWithOptions: () => {
    {
      return differenceInHoursWithOptions;
    }
  },
  differenceInHours: () => {
    {
      return differenceInHours3;
    }
  },
  differenceInDays: () => {
    {
      return differenceInDays3;
    }
  },
  differenceInCalendarYears: () => {
    {
      return differenceInCalendarYears3;
    }
  },
  differenceInCalendarWeeksWithOptions: () => {
    {
      return differenceInCalendarWeeksWithOptions;
    }
  },
  differenceInCalendarWeeks: () => {
    {
      return differenceInCalendarWeeks3;
    }
  },
  differenceInCalendarQuarters: () => {
    {
      return differenceInCalendarQuarters3;
    }
  },
  differenceInCalendarMonths: () => {
    {
      return differenceInCalendarMonths3;
    }
  },
  differenceInCalendarISOWeeks: () => {
    {
      return differenceInCalendarISOWeeks3;
    }
  },
  differenceInCalendarISOWeekYears: () => {
    {
      return differenceInCalendarISOWeekYears3;
    }
  },
  differenceInCalendarDays: () => {
    {
      return differenceInCalendarDays5;
    }
  },
  differenceInBusinessDays: () => {
    {
      return differenceInBusinessDays3;
    }
  },
  daysToWeeks: () => {
    {
      return daysToWeeks3;
    }
  },
  constructFrom: () => {
    {
      return constructFrom12;
    }
  },
  compareDesc: () => {
    {
      return compareDesc3;
    }
  },
  compareAsc: () => {
    {
      return compareAsc3;
    }
  },
  closestTo: () => {
    {
      return closestTo3;
    }
  },
  closestIndexTo: () => {
    {
      return closestIndexTo3;
    }
  },
  clamp: () => {
    {
      return clamp3;
    }
  },
  areIntervalsOverlappingWithOptions: () => {
    {
      return areIntervalsOverlappingWithOptions;
    }
  },
  areIntervalsOverlapping: () => {
    {
      return areIntervalsOverlapping3;
    }
  },
  addYears: () => {
    {
      return addYears3;
    }
  },
  addWeeks: () => {
    {
      return addWeeks3;
    }
  },
  addSeconds: () => {
    {
      return addSeconds3;
    }
  },
  addQuarters: () => {
    {
      return addQuarters3;
    }
  },
  addMonths: () => {
    {
      return addMonths4;
    }
  },
  addMinutes: () => {
    {
      return addMinutes3;
    }
  },
  addMilliseconds: () => {
    {
      return addMilliseconds4;
    }
  },
  addISOWeekYears: () => {
    {
      return addISOWeekYears3;
    }
  },
  addHours: () => {
    {
      return addHours3;
    }
  },
  addDays: () => {
    {
      return addDays4;
    }
  },
  addBusinessDays: () => {
    {
      return addBusinessDays3;
    }
  },
  add: () => {
    {
      return add3;
    }
  }
});

// ../../../../../../tmp/date-fns-jalali/_lib/jalali.mjs
function toJalali(gy, gm, gd) {
  return d2j(g2d(gy, gm, gd));
}
function toGregorian(jy, jm, jd) {
  return d2g(j2d(jy, jm, jd));
}
function isLeapJalaliYear(jy) {
  if (jy === -3) {
    return false;
  }
  const m = mod(25 * jy + 11, 33);
  return m < 8 && m >= -1 || m <= -27;
}
function j2d(jy, jm, jd) {
  const [ny, nm] = normalizeMonth(jy, jm);
  jy = ny;
  jm = nm;
  const month = jm - 1;
  const year = jy;
  const day = jd;
  let julianDay = PERSIAN_EPOCH - 1 + 365 * (year - 1) + div(8 * year + 21, 33);
  if (month != 0) {
    julianDay += PERSIAN_NUM_DAYS[month];
  }
  return julianDay + day;
}
function d2j(julianDay) {
  if (isNaN(julianDay)) {
    return { jy: NaN, jm: NaN, jd: NaN };
  }
  let month, dayOfYear;
  const daysSinceEpoch = julianDay - PERSIAN_EPOCH;
  let year = 1 + div(33 * daysSinceEpoch + 3, 12053);
  dayOfYear = daysSinceEpoch - (365 * (year - 1) + div(8 * year + 21, 33));
  if (dayOfYear < 0) {
    year--;
    dayOfYear = daysSinceEpoch - (365 * (year - 1) + div(8 * year + 21, 33));
  }
  if (dayOfYear < 216) {
    month = div(dayOfYear, 31);
  } else {
    month = div(dayOfYear - 6, 30);
  }
  const dayOfMonth = dayOfYear - PERSIAN_NUM_DAYS[month] + 1;
  dayOfYear++;
  const jy = year;
  const jm = month + 1;
  const jd = dayOfMonth;
  return { jy, jm, jd };
}
function g2d(gy, gm, gd) {
  const [ny, nm] = normalizeMonth(gy, gm);
  gy = ny;
  gm = nm;
  return div(1461 * (gy + 4800 + div(gm - 14, 12)), 4) + div(367 * (gm - 2 - 12 * div(gm - 14, 12)), 12) - div(3 * div(gy + 4900 + div(gm - 14, 12), 100), 4) + gd - 32075;
}
function d2g(jdn) {
  if (isNaN(jdn)) {
    return { gy: NaN, gm: NaN, gd: NaN };
  }
  let L = jdn + 68569;
  const n = div(4 * L, 146097);
  L = L - div(146097 * n + 3, 4);
  const i = div(4000 * (L + 1), 1461001);
  L = L - div(1461 * i, 4) + 31;
  const j = div(80 * L, 2447);
  const gd = L - div(2447 * j, 80);
  L = div(j, 11);
  const gm = j + 2 - 12 * L;
  const gy = 100 * (n - 49) + i + L;
  return { gy, gm, gd };
}
function normalizeMonth(year, month) {
  month = month - 1;
  if (month < 0) {
    const old_month = month;
    month = pmod(month, 12);
    year -= div(month - old_month, 12);
  }
  if (month > 11) {
    year += div(month, 12);
    month = mod(month, 12);
  }
  return [year, month + 1];
}
var div = function(a, b) {
  return ~~(a / b);
};
var mod = function(a, b) {
  return a - ~~(a / b) * b;
};
var pmod = function(a, b) {
  return mod(mod(a, b) + b, b);
};
var PERSIAN_EPOCH = 1948320;
var PERSIAN_NUM_DAYS = [
  0,
  31,
  62,
  93,
  124,
  155,
  186,
  216,
  246,
  276,
  306,
  336
];

// ../../../../../../tmp/date-fns-jalali/_core/newDate.mjs
function newDate(...args) {
  if (args.length > 1) {
    const [year, month, day = 1, ...rest] = args;
    const g = toGregorian(year, month + 1, day);
    return new Date(...[g.gy, g.gm - 1, g.gd, ...rest]);
  }
  return new Date(...args);
}

// ../../../../../../tmp/date-fns-jalali/toDate.mjs
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
    return new argument.constructor(+argument);
  } else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") {
    return newDate(argument);
  } else {
    return newDate(NaN);
  }
}

// ../../../../../../tmp/date-fns-jalali/constructFrom.mjs
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return newDate(value);
  }
}

// ../../../../../../tmp/date-fns-jalali/_core/getDate.mjs
function getDate(cleanDate) {
  const gd = cleanDate.getDate();
  const gm = cleanDate.getMonth() + 1;
  const gy = cleanDate.getFullYear();
  return toJalali(gy, gm, gd).jd;
}

// ../../../../../../tmp/date-fns-jalali/_core/setDate.mjs
function setDate(cleanDate, ...args) {
  const gd = cleanDate.getDate();
  const gm = cleanDate.getMonth() + 1;
  const gy = cleanDate.getFullYear();
  const j = toJalali(gy, gm, gd);
  const [date] = args;
  const g = toGregorian(j.jy, j.jm, date);
  return cleanDate.setFullYear(g.gy, g.gm - 1, g.gd);
}

// ../../../../../../tmp/date-fns-jalali/addDays.mjs
function addDays(date, amount) {
  const _date = toDate(date);
  if (isNaN(amount))
    return constructFrom(date, NaN);
  if (!amount) {
    return _date;
  }
  setDate(_date, getDate(_date) + amount);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/_core/getMonth.mjs
function getMonth(cleanDate) {
  const gd = cleanDate.getDate();
  const gm = cleanDate.getMonth() + 1;
  const gy = cleanDate.getFullYear();
  return toJalali(gy, gm, gd).jm - 1;
}

// ../../../../../../tmp/date-fns-jalali/_core/setMonth.mjs
function setMonth(cleanDate, ...args) {
  const gd = cleanDate.getDate();
  const gm = cleanDate.getMonth() + 1;
  const gy = cleanDate.getFullYear();
  const j = toJalali(gy, gm, gd);
  const [month, date = j.jd] = args;
  const g = toGregorian(j.jy, month + 1, date);
  return cleanDate.setFullYear(g.gy, g.gm - 1, g.gd);
}

// ../../../../../../tmp/date-fns-jalali/_core/getFullYear.mjs
function getFullYear(cleanDate) {
  const gd = cleanDate.getDate();
  const gm = cleanDate.getMonth() + 1;
  const gy = cleanDate.getFullYear();
  return toJalali(gy, gm, gd).jy;
}

// ../../../../../../tmp/date-fns-jalali/_core/setFullYear.mjs
function setFullYear(cleanDate, ...args) {
  const gd = cleanDate.getDate();
  const gm = cleanDate.getMonth() + 1;
  const gy = cleanDate.getFullYear();
  const j = toJalali(gy, gm, gd);
  const [year, month = j.jm - 1, date = j.jd] = args;
  const g = toGregorian(year, month + 1, date);
  return cleanDate.setFullYear(g.gy, g.gm - 1, g.gd);
}

// ../../../../../../tmp/date-fns-jalali/addMonths.mjs
function addMonths(date, amount) {
  const _date = toDate(date);
  if (isNaN(amount))
    return constructFrom(date, NaN);
  if (!amount) {
    return _date;
  }
  const dayOfMonth = getDate(_date);
  const endOfDesiredMonth = constructFrom(date, _date.getTime());
  setMonth(endOfDesiredMonth, getMonth(_date) + amount + 1, 0);
  const daysInMonth = getDate(endOfDesiredMonth);
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    setFullYear(_date, getFullYear(endOfDesiredMonth), getMonth(endOfDesiredMonth), dayOfMonth);
    return _date;
  }
}

// ../../../../../../tmp/date-fns-jalali/add.mjs
function add(date, duration) {
  const {
    years = 0,
    months = 0,
    weeks = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  } = duration;
  const _date = toDate(date);
  const dateWithMonths = months || years ? addMonths(_date, months + years * 12) : _date;
  const dateWithDays = days || weeks ? addDays(dateWithMonths, days + weeks * 7) : dateWithMonths;
  const minutesToAdd = minutes + hours * 60;
  const secondsToAdd = seconds + minutesToAdd * 60;
  const msToAdd = secondsToAdd * 1000;
  const finalDate = constructFrom(date, dateWithDays.getTime() + msToAdd);
  return finalDate;
}

// ../../../../../../tmp/date-fns-jalali/fp/_lib/convertToFP.mjs
function convertToFP(fn, arity, curriedArgs = []) {
  return curriedArgs.length >= arity ? fn(...curriedArgs.slice(0, arity).reverse()) : (...args) => convertToFP(fn, arity, curriedArgs.concat(args));
}

// ../../../../../../tmp/date-fns-jalali/fp/add.mjs
var add3 = convertToFP(add, 2);
// ../../../../../../tmp/date-fns-jalali/isSaturday.mjs
function isSaturday(date) {
  return toDate(date).getDay() === 6;
}

// ../../../../../../tmp/date-fns-jalali/isSunday.mjs
function isSunday(date) {
  return toDate(date).getDay() === 0;
}

// ../../../../../../tmp/date-fns-jalali/isWeekend.mjs
function isWeekend(date) {
  const day = toDate(date).getDay();
  return day === 0 || day === 6;
}

// ../../../../../../tmp/date-fns-jalali/addBusinessDays.mjs
function addBusinessDays(date, amount) {
  const _date = toDate(date);
  const startedOnWeekend = isWeekend(_date);
  if (isNaN(amount))
    return constructFrom(date, NaN);
  const hours = _date.getHours();
  const sign = amount < 0 ? -1 : 1;
  const fullWeeks = Math.trunc(amount / 5);
  setDate(_date, getDate(_date) + fullWeeks * 7);
  let restDays = Math.abs(amount % 5);
  while (restDays > 0) {
    setDate(_date, getDate(_date) + sign);
    if (!isWeekend(_date))
      restDays -= 1;
  }
  if (startedOnWeekend && isWeekend(_date) && amount !== 0) {
    if (isSaturday(_date))
      setDate(_date, getDate(_date) + (sign < 0 ? 2 : -1));
    if (isSunday(_date))
      setDate(_date, getDate(_date) + (sign < 0 ? 1 : -2));
  }
  _date.setHours(hours);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/addBusinessDays.mjs
var addBusinessDays3 = convertToFP(addBusinessDays, 2);
// ../../../../../../tmp/date-fns-jalali/fp/addDays.mjs
var addDays4 = convertToFP(addDays, 2);
// ../../../../../../tmp/date-fns-jalali/addMilliseconds.mjs
function addMilliseconds(date, amount) {
  const timestamp = +toDate(date);
  return constructFrom(date, timestamp + amount);
}

// ../../../../../../tmp/date-fns-jalali/constants.mjs
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
var minTime = -maxTime;
var millisecondsInWeek = 604800000;
var millisecondsInDay = 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minutesInYear = 525600;
var minutesInMonth = 43200;
var minutesInDay = 1440;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;

// ../../../../../../tmp/date-fns-jalali/addHours.mjs
function addHours(date, amount) {
  return addMilliseconds(date, amount * millisecondsInHour);
}

// ../../../../../../tmp/date-fns-jalali/fp/addHours.mjs
var addHours3 = convertToFP(addHours, 2);
// ../../../../../../tmp/date-fns-jalali/_lib/defaultOptions.mjs
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}
var defaultOptions = {};

// ../../../../../../tmp/date-fns-jalali/startOfWeek.mjs
function startOfWeek(date, options) {
  const defaultOptions3 = getDefaultOptions();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions3.weekStartsOn ?? defaultOptions3.locale?.options?.weekStartsOn ?? 6;
  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  setDate(_date, getDate(_date) - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/startOfISOWeek.mjs
function startOfISOWeek(date) {
  return startOfWeek(date, { weekStartsOn: 1 });
}

// ../../../../../../tmp/date-fns-jalali/getISOWeekYear.mjs
function getISOWeekYear(date) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  const fourthOfJanuaryOfNextYear = constructFrom(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  const fourthOfJanuaryOfThisYear = constructFrom(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// ../../../../../../tmp/date-fns-jalali/startOfDay.mjs
function startOfDay(date) {
  const _date = toDate(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/_lib/getTimezoneOffsetInMilliseconds.mjs
function getTimezoneOffsetInMilliseconds(date) {
  const _date = toDate(date);
  const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}

// ../../../../../../tmp/date-fns-jalali/differenceInCalendarDays.mjs
function differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = startOfDay(dateLeft);
  const startOfDayRight = startOfDay(dateRight);
  const timestampLeft = +startOfDayLeft - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  const timestampRight = +startOfDayRight - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / millisecondsInDay);
}

// ../../../../../../tmp/date-fns-jalali/startOfISOWeekYear.mjs
function startOfISOWeekYear(date) {
  const year = getISOWeekYear(date);
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}

// ../../../../../../tmp/date-fns-jalali/setISOWeekYear.mjs
function setISOWeekYear(date, weekYear) {
  let _date = toDate(date);
  const diff = differenceInCalendarDays(_date, startOfISOWeekYear(_date));
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(weekYear, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  _date = startOfISOWeekYear(fourthOfJanuary);
  _date.setDate(_date.getDate() + diff);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/addISOWeekYears.mjs
function addISOWeekYears(date, amount) {
  return setISOWeekYear(date, getISOWeekYear(date) + amount);
}

// ../../../../../../tmp/date-fns-jalali/fp/addISOWeekYears.mjs
var addISOWeekYears3 = convertToFP(addISOWeekYears, 2);
// ../../../../../../tmp/date-fns-jalali/fp/addMilliseconds.mjs
var addMilliseconds4 = convertToFP(addMilliseconds, 2);
// ../../../../../../tmp/date-fns-jalali/addMinutes.mjs
function addMinutes(date, amount) {
  return addMilliseconds(date, amount * millisecondsInMinute);
}

// ../../../../../../tmp/date-fns-jalali/fp/addMinutes.mjs
var addMinutes3 = convertToFP(addMinutes, 2);
// ../../../../../../tmp/date-fns-jalali/fp/addMonths.mjs
var addMonths4 = convertToFP(addMonths, 2);
// ../../../../../../tmp/date-fns-jalali/addQuarters.mjs
function addQuarters(date, amount) {
  const months = amount * 3;
  return addMonths(date, months);
}

// ../../../../../../tmp/date-fns-jalali/fp/addQuarters.mjs
var addQuarters3 = convertToFP(addQuarters, 2);
// ../../../../../../tmp/date-fns-jalali/addSeconds.mjs
function addSeconds(date, amount) {
  return addMilliseconds(date, amount * 1000);
}

// ../../../../../../tmp/date-fns-jalali/fp/addSeconds.mjs
var addSeconds3 = convertToFP(addSeconds, 2);
// ../../../../../../tmp/date-fns-jalali/addWeeks.mjs
function addWeeks(date, amount) {
  const days = amount * 7;
  return addDays(date, days);
}

// ../../../../../../tmp/date-fns-jalali/fp/addWeeks.mjs
var addWeeks3 = convertToFP(addWeeks, 2);
// ../../../../../../tmp/date-fns-jalali/addYears.mjs
function addYears(date, amount) {
  return addMonths(date, amount * 12);
}

// ../../../../../../tmp/date-fns-jalali/fp/addYears.mjs
var addYears3 = convertToFP(addYears, 2);
// ../../../../../../tmp/date-fns-jalali/areIntervalsOverlapping.mjs
function areIntervalsOverlapping(intervalLeft, intervalRight, options) {
  const [leftStartTime, leftEndTime] = [
    +toDate(intervalLeft.start),
    +toDate(intervalLeft.end)
  ].sort((a, b) => a - b);
  const [rightStartTime, rightEndTime] = [
    +toDate(intervalRight.start),
    +toDate(intervalRight.end)
  ].sort((a, b) => a - b);
  if (options?.inclusive)
    return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}

// ../../../../../../tmp/date-fns-jalali/fp/areIntervalsOverlapping.mjs
var areIntervalsOverlapping3 = convertToFP(areIntervalsOverlapping, 2);
// ../../../../../../tmp/date-fns-jalali/fp/areIntervalsOverlappingWithOptions.mjs
var areIntervalsOverlappingWithOptions = convertToFP(areIntervalsOverlapping, 3);
// ../../../../../../tmp/date-fns-jalali/max.mjs
function max(dates) {
  let result;
  dates.forEach(function(dirtyDate) {
    const currentDate = toDate(dirtyDate);
    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || newDate(NaN);
}

// ../../../../../../tmp/date-fns-jalali/min.mjs
function min(dates) {
  let result;
  dates.forEach((dirtyDate) => {
    const date = toDate(dirtyDate);
    if (!result || result > date || isNaN(+date)) {
      result = date;
    }
  });
  return result || newDate(NaN);
}

// ../../../../../../tmp/date-fns-jalali/clamp.mjs
function clamp(date, interval) {
  return min([max([date, interval.start]), interval.end]);
}

// ../../../../../../tmp/date-fns-jalali/fp/clamp.mjs
var clamp3 = convertToFP(clamp, 2);
// ../../../../../../tmp/date-fns-jalali/closestIndexTo.mjs
function closestIndexTo(dateToCompare, dates) {
  const date = toDate(dateToCompare);
  if (isNaN(Number(date)))
    return NaN;
  const timeToCompare = date.getTime();
  let result;
  let minDistance;
  dates.forEach(function(dirtyDate, index) {
    const currentDate = toDate(dirtyDate);
    if (isNaN(Number(currentDate))) {
      result = NaN;
      minDistance = NaN;
      return;
    }
    const distance = Math.abs(timeToCompare - currentDate.getTime());
    if (result == null || distance < minDistance) {
      result = index;
      minDistance = distance;
    }
  });
  return result;
}

// ../../../../../../tmp/date-fns-jalali/fp/closestIndexTo.mjs
var closestIndexTo3 = convertToFP(closestIndexTo, 2);
// ../../../../../../tmp/date-fns-jalali/closestTo.mjs
function closestTo(dateToCompare, dates) {
  const date = toDate(dateToCompare);
  if (isNaN(Number(date)))
    return constructFrom(dateToCompare, NaN);
  const timeToCompare = date.getTime();
  let result;
  let minDistance;
  dates.forEach((dirtyDate) => {
    const currentDate = toDate(dirtyDate);
    if (isNaN(Number(currentDate))) {
      result = constructFrom(dateToCompare, NaN);
      minDistance = NaN;
      return;
    }
    const distance = Math.abs(timeToCompare - currentDate.getTime());
    if (result == null || distance < minDistance) {
      result = currentDate;
      minDistance = distance;
    }
  });
  return result;
}

// ../../../../../../tmp/date-fns-jalali/fp/closestTo.mjs
var closestTo3 = convertToFP(closestTo, 2);
// ../../../../../../tmp/date-fns-jalali/compareAsc.mjs
function compareAsc(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const diff = _dateLeft.getTime() - _dateRight.getTime();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}

// ../../../../../../tmp/date-fns-jalali/fp/compareAsc.mjs
var compareAsc3 = convertToFP(compareAsc, 2);
// ../../../../../../tmp/date-fns-jalali/compareDesc.mjs
function compareDesc(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const diff = _dateLeft.getTime() - _dateRight.getTime();
  if (diff > 0) {
    return -1;
  } else if (diff < 0) {
    return 1;
  } else {
    return diff;
  }
}

// ../../../../../../tmp/date-fns-jalali/fp/compareDesc.mjs
var compareDesc3 = convertToFP(compareDesc, 2);
// ../../../../../../tmp/date-fns-jalali/fp/constructFrom.mjs
var constructFrom12 = convertToFP(constructFrom, 2);
// ../../../../../../tmp/date-fns-jalali/daysToWeeks.mjs
function daysToWeeks(days) {
  const weeks = days / daysInWeek;
  const result = Math.trunc(weeks);
  return result === 0 ? 0 : result;
}

// ../../../../../../tmp/date-fns-jalali/fp/daysToWeeks.mjs
var daysToWeeks3 = convertToFP(daysToWeeks, 1);
// ../../../../../../tmp/date-fns-jalali/isSameDay.mjs
function isSameDay(dateLeft, dateRight) {
  const dateLeftStartOfDay = startOfDay(dateLeft);
  const dateRightStartOfDay = startOfDay(dateRight);
  return +dateLeftStartOfDay === +dateRightStartOfDay;
}

// ../../../../../../tmp/date-fns-jalali/isDate.mjs
function isDate(value) {
  return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

// ../../../../../../tmp/date-fns-jalali/isValid.mjs
function isValid(date) {
  if (!isDate(date) && typeof date !== "number") {
    return false;
  }
  const _date = toDate(date);
  return !isNaN(Number(_date));
}

// ../../../../../../tmp/date-fns-jalali/differenceInBusinessDays.mjs
function differenceInBusinessDays(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  let _dateRight = toDate(dateRight);
  if (!isValid(_dateLeft) || !isValid(_dateRight))
    return NaN;
  const calendarDifference = differenceInCalendarDays(_dateLeft, _dateRight);
  const sign = calendarDifference < 0 ? -1 : 1;
  const weeks = Math.trunc(calendarDifference / 7);
  let result = weeks * 5;
  _dateRight = addDays(_dateRight, weeks * 7);
  while (!isSameDay(_dateLeft, _dateRight)) {
    result += isWeekend(_dateRight) ? 0 : sign;
    _dateRight = addDays(_dateRight, sign);
  }
  return result === 0 ? 0 : result;
}

// ../../../../../../tmp/date-fns-jalali/fp/differenceInBusinessDays.mjs
var differenceInBusinessDays3 = convertToFP(differenceInBusinessDays, 2);
// ../../../../../../tmp/date-fns-jalali/fp/differenceInCalendarDays.mjs
var differenceInCalendarDays5 = convertToFP(differenceInCalendarDays, 2);
// ../../../../../../tmp/date-fns-jalali/differenceInCalendarISOWeekYears.mjs
function differenceInCalendarISOWeekYears(dateLeft, dateRight) {
  return getISOWeekYear(dateLeft) - getISOWeekYear(dateRight);
}

// ../../../../../../tmp/date-fns-jalali/fp/differenceInCalendarISOWeekYears.mjs
var differenceInCalendarISOWeekYears3 = convertToFP(differenceInCalendarISOWeekYears, 2);
// ../../../../../../tmp/date-fns-jalali/differenceInCalendarISOWeeks.mjs
function differenceInCalendarISOWeeks(dateLeft, dateRight) {
  const startOfISOWeekLeft = startOfISOWeek(dateLeft);
  const startOfISOWeekRight = startOfISOWeek(dateRight);
  const timestampLeft = +startOfISOWeekLeft - getTimezoneOffsetInMilliseconds(startOfISOWeekLeft);
  const timestampRight = +startOfISOWeekRight - getTimezoneOffsetInMilliseconds(startOfISOWeekRight);
  return Math.round((timestampLeft - timestampRight) / millisecondsInWeek);
}

// ../../../../../../tmp/date-fns-jalali/fp/differenceInCalendarISOWeeks.mjs
var differenceInCalendarISOWeeks3 = convertToFP(differenceInCalendarISOWeeks, 2);
// ../../../../../../tmp/date-fns-jalali/differenceInCalendarMonths.mjs
function differenceInCalendarMonths(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const yearDiff = getFullYear(_dateLeft) - getFullYear(_dateRight);
  const monthDiff = getMonth(_dateLeft) - getMonth(_dateRight);
  return yearDiff * 12 + monthDiff;
}

// ../../../../../../tmp/date-fns-jalali/fp/differenceInCalendarMonths.mjs
var differenceInCalendarMonths3 = convertToFP(differenceInCalendarMonths, 2);
// ../../../../../../tmp/date-fns-jalali/getQuarter.mjs
function getQuarter(date) {
  const _date = toDate(date);
  const quarter = Math.trunc(getMonth(_date) / 3) + 1;
  return quarter;
}

// ../../../../../../tmp/date-fns-jalali/differenceInCalendarQuarters.mjs
function differenceInCalendarQuarters(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const yearDiff = getFullYear(_dateLeft) - getFullYear(_dateRight);
  const quarterDiff = getQuarter(_dateLeft) - getQuarter(_dateRight);
  return yearDiff * 4 + quarterDiff;
}

// ../../../../../../tmp/date-fns-jalali/fp/differenceInCalendarQuarters.mjs
var differenceInCalendarQuarters3 = convertToFP(differenceInCalendarQuarters, 2);
// ../../../../../../tmp/date-fns-jalali/differenceInCalendarWeeks.mjs
function differenceInCalendarWeeks(dateLeft, dateRight, options) {
  const startOfWeekLeft = startOfWeek(dateLeft, options);
  const startOfWeekRight = startOfWeek(dateRight, options);
  const timestampLeft = +startOfWeekLeft - getTimezoneOffsetInMilliseconds(startOfWeekLeft);
  const timestampRight = +startOfWeekRight - getTimezoneOffsetInMilliseconds(startOfWeekRight);
  return Math.round((timestampLeft - timestampRight) / millisecondsInWeek);
}

// ../../../../../../tmp/date-fns-jalali/fp/differenceInCalendarWeeks.mjs
var differenceInCalendarWeeks3 = convertToFP(differenceInCalendarWeeks, 2);
// ../../../../../../tmp/date-fns-jalali/fp/differenceInCalendarWeeksWithOptions.mjs
var differenceInCalendarWeeksWithOptions = convertToFP(differenceInCalendarWeeks, 3);
// ../../../../../../tmp/date-fns-jalali/differenceInCalendarYears.mjs
function differenceInCalendarYears(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  return getFullYear(_dateLeft) - getFullYear(_dateRight);
}

// ../../../../../../tmp/date-fns-jalali/fp/differenceInCalendarYears.mjs
var differenceInCalendarYears3 = convertToFP(differenceInCalendarYears, 2);
// ../../../../../../tmp/date-fns-jalali/differenceInDays.mjs
function differenceInDays(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const sign = compareLocalAsc(_dateLeft, _dateRight);
  const difference = Math.abs(differenceInCalendarDays(_dateLeft, _dateRight));
  setDate(_dateLeft, getDate(_dateLeft) - sign * difference);
  const isLastDayNotFull = Number(compareLocalAsc(_dateLeft, _dateRight) === -sign);
  const result = sign * (difference - isLastDayNotFull);
  return result === 0 ? 0 : result;
}
var compareLocalAsc = function(dateLeft, dateRight) {
  const diff = getFullYear(dateLeft) - getFullYear(dateRight) || getMonth(dateLeft) - getMonth(dateRight) || getDate(dateLeft) - getDate(dateRight) || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
};

// ../../../../../../tmp/date-fns-jalali/fp/differenceInDays.mjs
var differenceInDays3 = convertToFP(differenceInDays, 2);
// ../../../../../../tmp/date-fns-jalali/_lib/getRoundingMethod.mjs
function getRoundingMethod(method) {
  return (number) => {
    const round = method ? Math[method] : Math.trunc;
    const result = round(number);
    return result === 0 ? 0 : result;
  };
}

// ../../../../../../tmp/date-fns-jalali/differenceInMilliseconds.mjs
function differenceInMilliseconds(dateLeft, dateRight) {
  return +toDate(dateLeft) - +toDate(dateRight);
}

// ../../../../../../tmp/date-fns-jalali/differenceInHours.mjs
function differenceInHours(dateLeft, dateRight, options) {
  const diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInHour;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

// ../../../../../../tmp/date-fns-jalali/fp/differenceInHours.mjs
var differenceInHours3 = convertToFP(differenceInHours, 2);
// ../../../../../../tmp/date-fns-jalali/fp/differenceInHoursWithOptions.mjs
var differenceInHoursWithOptions = convertToFP(differenceInHours, 3);
// ../../../../../../tmp/date-fns-jalali/subISOWeekYears.mjs
function subISOWeekYears(date, amount) {
  return addISOWeekYears(date, -amount);
}

// ../../../../../../tmp/date-fns-jalali/differenceInISOWeekYears.mjs
function differenceInISOWeekYears(dateLeft, dateRight) {
  let _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const sign = compareAsc(_dateLeft, _dateRight);
  const difference = Math.abs(differenceInCalendarISOWeekYears(_dateLeft, _dateRight));
  _dateLeft = subISOWeekYears(_dateLeft, sign * difference);
  const isLastISOWeekYearNotFull = Number(compareAsc(_dateLeft, _dateRight) === -sign);
  const result = sign * (difference - isLastISOWeekYearNotFull);
  return result === 0 ? 0 : result;
}

// ../../../../../../tmp/date-fns-jalali/fp/differenceInISOWeekYears.mjs
var differenceInISOWeekYears3 = convertToFP(differenceInISOWeekYears, 2);
// ../../../../../../tmp/date-fns-jalali/fp/differenceInMilliseconds.mjs
var differenceInMilliseconds4 = convertToFP(differenceInMilliseconds, 2);
// ../../../../../../tmp/date-fns-jalali/differenceInMinutes.mjs
function differenceInMinutes(dateLeft, dateRight, options) {
  const diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

// ../../../../../../tmp/date-fns-jalali/fp/differenceInMinutes.mjs
var differenceInMinutes3 = convertToFP(differenceInMinutes, 2);
// ../../../../../../tmp/date-fns-jalali/fp/differenceInMinutesWithOptions.mjs
var differenceInMinutesWithOptions = convertToFP(differenceInMinutes, 3);
// ../../../../../../tmp/date-fns-jalali/endOfDay.mjs
function endOfDay(date) {
  const _date = toDate(date);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/endOfMonth.mjs
function endOfMonth(date) {
  const _date = toDate(date);
  const month = getMonth(_date);
  setFullYear(_date, getFullYear(_date), month + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/isLastDayOfMonth.mjs
function isLastDayOfMonth(date) {
  const _date = toDate(date);
  return +endOfDay(_date) === +endOfMonth(_date);
}

// ../../../../../../tmp/date-fns-jalali/differenceInMonths.mjs
function differenceInMonths(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const sign = compareAsc(_dateLeft, _dateRight);
  const difference = Math.abs(differenceInCalendarMonths(_dateLeft, _dateRight));
  let result;
  if (difference < 1) {
    result = 0;
  } else {
    if (getMonth(_dateLeft) === 11 && getDate(_dateLeft) > 28) {
      setDate(_dateLeft, 30);
    }
    setMonth(_dateLeft, getMonth(_dateLeft) - sign * difference);
    let isLastMonthNotFull = compareAsc(_dateLeft, _dateRight) === -sign;
    if (isLastDayOfMonth(toDate(dateLeft)) && difference === 1 && compareAsc(dateLeft, _dateRight) === 1) {
      isLastMonthNotFull = false;
    }
    result = sign * (difference - Number(isLastMonthNotFull));
  }
  return result === 0 ? 0 : result;
}

// ../../../../../../tmp/date-fns-jalali/fp/differenceInMonths.mjs
var differenceInMonths3 = convertToFP(differenceInMonths, 2);
// ../../../../../../tmp/date-fns-jalali/differenceInQuarters.mjs
function differenceInQuarters(dateLeft, dateRight, options) {
  const diff = differenceInMonths(dateLeft, dateRight) / 3;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

// ../../../../../../tmp/date-fns-jalali/fp/differenceInQuarters.mjs
var differenceInQuarters3 = convertToFP(differenceInQuarters, 2);
// ../../../../../../tmp/date-fns-jalali/fp/differenceInQuartersWithOptions.mjs
var differenceInQuartersWithOptions = convertToFP(differenceInQuarters, 3);
// ../../../../../../tmp/date-fns-jalali/differenceInSeconds.mjs
function differenceInSeconds(dateLeft, dateRight, options) {
  const diff = differenceInMilliseconds(dateLeft, dateRight) / 1000;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

// ../../../../../../tmp/date-fns-jalali/fp/differenceInSeconds.mjs
var differenceInSeconds3 = convertToFP(differenceInSeconds, 2);
// ../../../../../../tmp/date-fns-jalali/fp/differenceInSecondsWithOptions.mjs
var differenceInSecondsWithOptions = convertToFP(differenceInSeconds, 3);
// ../../../../../../tmp/date-fns-jalali/differenceInWeeks.mjs
function differenceInWeeks(dateLeft, dateRight, options) {
  const diff = differenceInDays(dateLeft, dateRight) / 7;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

// ../../../../../../tmp/date-fns-jalali/fp/differenceInWeeks.mjs
var differenceInWeeks3 = convertToFP(differenceInWeeks, 2);
// ../../../../../../tmp/date-fns-jalali/fp/differenceInWeeksWithOptions.mjs
var differenceInWeeksWithOptions = convertToFP(differenceInWeeks, 3);
// ../../../../../../tmp/date-fns-jalali/differenceInYears.mjs
function differenceInYears(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const sign = compareAsc(_dateLeft, _dateRight);
  const difference = Math.abs(differenceInCalendarYears(_dateLeft, _dateRight));
  setFullYear(_dateLeft, 1399);
  setFullYear(_dateRight, 1399);
  const isLastYearNotFull = compareAsc(_dateLeft, _dateRight) === -sign;
  const result = sign * (difference - +isLastYearNotFull);
  return result === 0 ? 0 : result;
}

// ../../../../../../tmp/date-fns-jalali/fp/differenceInYears.mjs
var differenceInYears3 = convertToFP(differenceInYears, 2);
// ../../../../../../tmp/date-fns-jalali/eachDayOfInterval.mjs
function eachDayOfInterval(interval, options) {
  const startDate = toDate(interval.start);
  const endDate = toDate(interval.end);
  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  const currentDate = reversed ? endDate : startDate;
  currentDate.setHours(0, 0, 0, 0);
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+currentDate <= endTime) {
    dates.push(toDate(currentDate));
    setDate(currentDate, getDate(currentDate) + step);
    currentDate.setHours(0, 0, 0, 0);
  }
  return reversed ? dates.reverse() : dates;
}

// ../../../../../../tmp/date-fns-jalali/fp/eachDayOfInterval.mjs
var eachDayOfInterval3 = convertToFP(eachDayOfInterval, 1);
// ../../../../../../tmp/date-fns-jalali/fp/eachDayOfIntervalWithOptions.mjs
var eachDayOfIntervalWithOptions = convertToFP(eachDayOfInterval, 2);
// ../../../../../../tmp/date-fns-jalali/eachHourOfInterval.mjs
function eachHourOfInterval(interval, options) {
  const startDate = toDate(interval.start);
  const endDate = toDate(interval.end);
  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  let currentDate = reversed ? endDate : startDate;
  currentDate.setMinutes(0, 0, 0);
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+currentDate <= endTime) {
    dates.push(toDate(currentDate));
    currentDate = addHours(currentDate, step);
  }
  return reversed ? dates.reverse() : dates;
}

// ../../../../../../tmp/date-fns-jalali/fp/eachHourOfInterval.mjs
var eachHourOfInterval3 = convertToFP(eachHourOfInterval, 1);
// ../../../../../../tmp/date-fns-jalali/fp/eachHourOfIntervalWithOptions.mjs
var eachHourOfIntervalWithOptions = convertToFP(eachHourOfInterval, 2);
// ../../../../../../tmp/date-fns-jalali/startOfMinute.mjs
function startOfMinute(date) {
  const _date = toDate(date);
  _date.setSeconds(0, 0);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/eachMinuteOfInterval.mjs
function eachMinuteOfInterval(interval, options) {
  const startDate = startOfMinute(toDate(interval.start));
  const endDate = toDate(interval.end);
  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  let currentDate = reversed ? endDate : startDate;
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+currentDate <= endTime) {
    dates.push(toDate(currentDate));
    currentDate = addMinutes(currentDate, step);
  }
  return reversed ? dates.reverse() : dates;
}

// ../../../../../../tmp/date-fns-jalali/fp/eachMinuteOfInterval.mjs
var eachMinuteOfInterval3 = convertToFP(eachMinuteOfInterval, 1);
// ../../../../../../tmp/date-fns-jalali/fp/eachMinuteOfIntervalWithOptions.mjs
var eachMinuteOfIntervalWithOptions = convertToFP(eachMinuteOfInterval, 2);
// ../../../../../../tmp/date-fns-jalali/eachMonthOfInterval.mjs
function eachMonthOfInterval(interval, options) {
  const startDate = toDate(interval.start);
  const endDate = toDate(interval.end);
  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  const currentDate = reversed ? endDate : startDate;
  currentDate.setHours(0, 0, 0, 0);
  setDate(currentDate, 1);
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+currentDate <= endTime) {
    dates.push(toDate(currentDate));
    setMonth(currentDate, getMonth(currentDate) + step);
  }
  return reversed ? dates.reverse() : dates;
}

// ../../../../../../tmp/date-fns-jalali/fp/eachMonthOfInterval.mjs
var eachMonthOfInterval3 = convertToFP(eachMonthOfInterval, 1);
// ../../../../../../tmp/date-fns-jalali/fp/eachMonthOfIntervalWithOptions.mjs
var eachMonthOfIntervalWithOptions = convertToFP(eachMonthOfInterval, 2);
// ../../../../../../tmp/date-fns-jalali/startOfQuarter.mjs
function startOfQuarter(date) {
  const _date = toDate(date);
  const currentMonth = getMonth(_date);
  const month = currentMonth - currentMonth % 3;
  setMonth(_date, month, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/eachQuarterOfInterval.mjs
function eachQuarterOfInterval(interval, options) {
  const startDate = toDate(interval.start);
  const endDate = toDate(interval.end);
  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startOfQuarter(startDate) : +startOfQuarter(endDate);
  let currentDate = reversed ? startOfQuarter(endDate) : startOfQuarter(startDate);
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+currentDate <= endTime) {
    dates.push(toDate(currentDate));
    currentDate = addQuarters(currentDate, step);
  }
  return reversed ? dates.reverse() : dates;
}

// ../../../../../../tmp/date-fns-jalali/fp/eachQuarterOfInterval.mjs
var eachQuarterOfInterval3 = convertToFP(eachQuarterOfInterval, 1);
// ../../../../../../tmp/date-fns-jalali/fp/eachQuarterOfIntervalWithOptions.mjs
var eachQuarterOfIntervalWithOptions = convertToFP(eachQuarterOfInterval, 2);
// ../../../../../../tmp/date-fns-jalali/eachWeekOfInterval.mjs
function eachWeekOfInterval(interval, options) {
  const startDate = toDate(interval.start);
  const endDate = toDate(interval.end);
  let reversed = +startDate > +endDate;
  const startDateWeek = reversed ? startOfWeek(endDate, options) : startOfWeek(startDate, options);
  const endDateWeek = reversed ? startOfWeek(startDate, options) : startOfWeek(endDate, options);
  startDateWeek.setHours(15);
  endDateWeek.setHours(15);
  const endTime = +endDateWeek.getTime();
  let currentDate = startDateWeek;
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+currentDate <= endTime) {
    currentDate.setHours(0);
    dates.push(toDate(currentDate));
    currentDate = addWeeks(currentDate, step);
    currentDate.setHours(15);
  }
  return reversed ? dates.reverse() : dates;
}

// ../../../../../../tmp/date-fns-jalali/fp/eachWeekOfInterval.mjs
var eachWeekOfInterval3 = convertToFP(eachWeekOfInterval, 1);
// ../../../../../../tmp/date-fns-jalali/fp/eachWeekOfIntervalWithOptions.mjs
var eachWeekOfIntervalWithOptions = convertToFP(eachWeekOfInterval, 2);
// ../../../../../../tmp/date-fns-jalali/eachWeekendOfInterval.mjs
function eachWeekendOfInterval(interval) {
  const dateInterval = eachDayOfInterval(interval);
  const weekends = [];
  let index = 0;
  while (index < dateInterval.length) {
    const date = dateInterval[index++];
    if (isWeekend(date))
      weekends.push(date);
  }
  return weekends;
}

// ../../../../../../tmp/date-fns-jalali/fp/eachWeekendOfInterval.mjs
var eachWeekendOfInterval3 = convertToFP(eachWeekendOfInterval, 1);
// ../../../../../../tmp/date-fns-jalali/startOfMonth.mjs
function startOfMonth(date) {
  const _date = toDate(date);
  setDate(_date, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/eachWeekendOfMonth.mjs
function eachWeekendOfMonth(date) {
  const start = startOfMonth(date);
  const end = endOfMonth(date);
  return eachWeekendOfInterval({ start, end });
}

// ../../../../../../tmp/date-fns-jalali/fp/eachWeekendOfMonth.mjs
var eachWeekendOfMonth3 = convertToFP(eachWeekendOfMonth, 1);
// ../../../../../../tmp/date-fns-jalali/endOfYear.mjs
function endOfYear(date) {
  const _date = toDate(date);
  const year = getFullYear(_date);
  setFullYear(_date, year + 1, 0, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/startOfYear.mjs
function startOfYear(date) {
  const cleanDate = toDate(date);
  const _date = constructFrom(date, 0);
  setFullYear(_date, getFullYear(cleanDate), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/eachWeekendOfYear.mjs
function eachWeekendOfYear(date) {
  const start = startOfYear(date);
  const end = endOfYear(date);
  return eachWeekendOfInterval({ start, end });
}

// ../../../../../../tmp/date-fns-jalali/fp/eachWeekendOfYear.mjs
var eachWeekendOfYear3 = convertToFP(eachWeekendOfYear, 1);
// ../../../../../../tmp/date-fns-jalali/eachYearOfInterval.mjs
function eachYearOfInterval(interval, options) {
  const startDate = toDate(interval.start);
  const endDate = toDate(interval.end);
  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  const currentDate = reversed ? endDate : startDate;
  currentDate.setHours(0, 0, 0, 0);
  setMonth(currentDate, 0, 1);
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+currentDate <= endTime) {
    dates.push(toDate(currentDate));
    setFullYear(currentDate, getFullYear(currentDate) + step);
  }
  return reversed ? dates.reverse() : dates;
}

// ../../../../../../tmp/date-fns-jalali/fp/eachYearOfInterval.mjs
var eachYearOfInterval3 = convertToFP(eachYearOfInterval, 1);
// ../../../../../../tmp/date-fns-jalali/fp/eachYearOfIntervalWithOptions.mjs
var eachYearOfIntervalWithOptions = convertToFP(eachYearOfInterval, 2);
// ../../../../../../tmp/date-fns-jalali/fp/endOfDay.mjs
var endOfDay4 = convertToFP(endOfDay, 1);
// ../../../../../../tmp/date-fns-jalali/endOfDecade.mjs
function endOfDecade(date) {
  const _date = toDate(date);
  const year = getFullYear(_date);
  const decade = 9 + Math.floor(year / 10) * 10;
  setFullYear(_date, decade + 1, 0, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/endOfDecade.mjs
var endOfDecade3 = convertToFP(endOfDecade, 1);
// ../../../../../../tmp/date-fns-jalali/endOfHour.mjs
function endOfHour(date) {
  const _date = toDate(date);
  _date.setMinutes(59, 59, 999);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/endOfHour.mjs
var endOfHour3 = convertToFP(endOfHour, 1);
// ../../../../../../tmp/date-fns-jalali/endOfWeek.mjs
function endOfWeek(date, options) {
  const defaultOptions4 = getDefaultOptions();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions4.weekStartsOn ?? defaultOptions4.locale?.options?.weekStartsOn ?? 6;
  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  setDate(_date, getDate(_date) + diff);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/endOfISOWeek.mjs
function endOfISOWeek(date) {
  return endOfWeek(date, { weekStartsOn: 1 });
}

// ../../../../../../tmp/date-fns-jalali/fp/endOfISOWeek.mjs
var endOfISOWeek3 = convertToFP(endOfISOWeek, 1);
// ../../../../../../tmp/date-fns-jalali/endOfISOWeekYear.mjs
function endOfISOWeekYear(date) {
  const year = getISOWeekYear(date);
  const fourthOfJanuaryOfNextYear = constructFrom(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const _date = startOfISOWeek(fourthOfJanuaryOfNextYear);
  _date.setMilliseconds(_date.getMilliseconds() - 1);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/endOfISOWeekYear.mjs
var endOfISOWeekYear3 = convertToFP(endOfISOWeekYear, 1);
// ../../../../../../tmp/date-fns-jalali/endOfMinute.mjs
function endOfMinute(date) {
  const _date = toDate(date);
  _date.setSeconds(59, 999);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/endOfMinute.mjs
var endOfMinute3 = convertToFP(endOfMinute, 1);
// ../../../../../../tmp/date-fns-jalali/fp/endOfMonth.mjs
var endOfMonth5 = convertToFP(endOfMonth, 1);
// ../../../../../../tmp/date-fns-jalali/endOfQuarter.mjs
function endOfQuarter(date) {
  const _date = toDate(date);
  const currentMonth = getMonth(_date);
  const month = currentMonth - currentMonth % 3 + 3;
  setMonth(_date, month, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/endOfQuarter.mjs
var endOfQuarter3 = convertToFP(endOfQuarter, 1);
// ../../../../../../tmp/date-fns-jalali/endOfSecond.mjs
function endOfSecond(date) {
  const _date = toDate(date);
  _date.setMilliseconds(999);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/endOfSecond.mjs
var endOfSecond3 = convertToFP(endOfSecond, 1);
// ../../../../../../tmp/date-fns-jalali/fp/endOfWeek.mjs
var endOfWeek4 = convertToFP(endOfWeek, 1);
// ../../../../../../tmp/date-fns-jalali/fp/endOfWeekWithOptions.mjs
var endOfWeekWithOptions = convertToFP(endOfWeek, 2);
// ../../../../../../tmp/date-fns-jalali/fp/endOfYear.mjs
var endOfYear4 = convertToFP(endOfYear, 1);
// ../../../../../../tmp/date-fns-jalali/locale/fa-IR/_lib/formatDistance.mjs
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062B\u0627\u0646\u06CC\u0647",
    other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062B\u0627\u0646\u06CC\u0647"
  },
  xSeconds: {
    one: "1 \u062B\u0627\u0646\u06CC\u0647",
    other: "{{count}} \u062B\u0627\u0646\u06CC\u0647"
  },
  halfAMinute: "\u0646\u06CC\u0645 \u062F\u0642\u06CC\u0642\u0647",
  lessThanXMinutes: {
    one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
    other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062F\u0642\u06CC\u0642\u0647"
  },
  xMinutes: {
    one: "1 \u062F\u0642\u06CC\u0642\u0647",
    other: "{{count}} \u062F\u0642\u06CC\u0642\u0647"
  },
  aboutXHours: {
    one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0639\u062A",
    other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0639\u062A"
  },
  xHours: {
    one: "1 \u0633\u0627\u0639\u062A",
    other: "{{count}} \u0633\u0627\u0639\u062A"
  },
  xDays: {
    one: "1 \u0631\u0648\u0632",
    other: "{{count}} \u0631\u0648\u0632"
  },
  aboutXWeeks: {
    one: "\u062D\u062F\u0648\u062F 1 \u0647\u0641\u062A\u0647",
    other: "\u062D\u062F\u0648\u062F {{count}} \u0647\u0641\u062A\u0647"
  },
  xWeeks: {
    one: "1 \u0647\u0641\u062A\u0647",
    other: "{{count}} \u0647\u0641\u062A\u0647"
  },
  aboutXMonths: {
    one: "\u062D\u062F\u0648\u062F 1 \u0645\u0627\u0647",
    other: "\u062D\u062F\u0648\u062F {{count}} \u0645\u0627\u0647"
  },
  xMonths: {
    one: "1 \u0645\u0627\u0647",
    other: "{{count}} \u0645\u0627\u0647"
  },
  aboutXYears: {
    one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0644",
    other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0644"
  },
  xYears: {
    one: "1 \u0633\u0627\u0644",
    other: "{{count}} \u0633\u0627\u0644"
  },
  overXYears: {
    one: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 1 \u0633\u0627\u0644",
    other: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 {{count}} \u0633\u0627\u0644"
  },
  almostXYears: {
    one: "\u0646\u0632\u062F\u06CC\u06A9 1 \u0633\u0627\u0644",
    other: "\u0646\u0632\u062F\u06CC\u06A9 {{count}} \u0633\u0627\u0644"
  }
};
var formatDistance = (token, count, options) => {
  let result;
  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "\u062F\u0631 " + result;
    } else {
      return result + " \u0642\u0628\u0644";
    }
  }
  return result;
};

// ../../../../../../tmp/date-fns-jalali/locale/_lib/buildFormatLongFn.mjs
function buildFormatLongFn(args) {
  return (options = {}) => {
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

// ../../../../../../tmp/date-fns-jalali/locale/fa-IR/_lib/formatLong.mjs
var dateFormats = {
  full: "EEEE do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "yyyy/MM/dd"
};
var timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats = {
  full: "{{date}} '\u062F\u0631' {{time}}",
  long: "{{date}} '\u062F\u0631' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};

// ../../../../../../tmp/date-fns-jalali/locale/fa-IR/_lib/formatRelative.mjs
var formatRelativeLocale = {
  lastWeek: "eeee '\u06AF\u0630\u0634\u062A\u0647 \u062F\u0631' p",
  yesterday: "'\u062F\u06CC\u0631\u0648\u0632 \u062F\u0631' p",
  today: "'\u0627\u0645\u0631\u0648\u0632 \u062F\u0631' p",
  tomorrow: "'\u0641\u0631\u062F\u0627 \u062F\u0631' p",
  nextWeek: "eeee '\u062F\u0631' p",
  other: "P"
};
var formatRelative = (token, _date, _baseDate, _options) => formatRelativeLocale[token];

// ../../../../../../tmp/date-fns-jalali/locale/_lib/buildLocalizeFn.mjs
function buildLocalizeFn(args) {
  return (value, options) => {
    const context = options?.context ? String(options.context) : "standalone";
    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options?.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;
    return valuesArray[index];
  };
}

// ../../../../../../tmp/date-fns-jalali/locale/fa-IR/_lib/localize.mjs
var eraValues = {
  narrow: ["\u0642", "\u0628"],
  abbreviated: ["\u0642.\u0647.", "\u0628.\u0647."],
  wide: ["\u0642\u0628\u0644 \u0627\u0632 \u0647\u062C\u0631\u062A", "\u0628\u0639\u062F \u0627\u0632 \u0647\u062C\u0631\u062A"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["\u0633\u200C\u06451", "\u0633\u200C\u06452", "\u0633\u200C\u06453", "\u0633\u200C\u06454"],
  wide: ["\u0633\u0647\u200C\u0645\u0627\u0647\u0647 1", "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 2", "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 3", "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 4"]
};
var monthValues = {
  narrow: [
    "\u0641\u0631",
    "\u0627\u0631",
    "\u062E\u0631",
    "\u062A\u06CC",
    "\u0645\u0631",
    "\u0634\u0647",
    "\u0645\u0647",
    "\u0622\u0628",
    "\u0622\u0630",
    "\u062F\u06CC",
    "\u0628\u0647",
    "\u0627\u0633"
  ],
  abbreviated: [
    "\u0641\u0631\u0648",
    "\u0627\u0631\u062F",
    "\u062E\u0631\u062F",
    "\u062A\u06CC\u0631",
    "\u0645\u0631\u062F",
    "\u0634\u0647\u0631",
    "\u0645\u0647\u0631",
    "\u0622\u0628\u0627",
    "\u0622\u0630\u0631",
    "\u062F\u06CC",
    "\u0628\u0647\u0645",
    "\u0627\u0633\u0641"
  ],
  wide: [
    "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
    "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
    "\u062E\u0631\u062F\u0627\u062F",
    "\u062A\u06CC\u0631",
    "\u0645\u0631\u062F\u0627\u062F",
    "\u0634\u0647\u0631\u06CC\u0648\u0631",
    "\u0645\u0647\u0631",
    "\u0622\u0628\u0627\u0646",
    "\u0622\u0630\u0631",
    "\u062F\u06CC",
    "\u0628\u0647\u0645\u0646",
    "\u0627\u0633\u0641\u0646\u062F"
  ]
};
var dayValues = {
  narrow: ["\u06CC", "\u062F", "\u0633", "\u0686", "\u067E", "\u062C", "\u0634"],
  short: ["1\u0634", "2\u0634", "3\u0634", "4\u0634", "5\u0634", "\u062C", "\u0634"],
  abbreviated: [
    "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647",
    "\u062F\u0648\u0634\u0646\u0628\u0647",
    "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
    "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
    "\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647",
    "\u062C\u0645\u0639\u0647",
    "\u0634\u0646\u0628\u0647"
  ],
  wide: [
    "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647",
    "\u062F\u0648\u0634\u0646\u0628\u0647",
    "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
    "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
    "\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647",
    "\u062C\u0645\u0639\u0647",
    "\u0634\u0646\u0628\u0647"
  ]
};
var dayPeriodValues = {
  narrow: {
    am: "\u0642",
    pm: "\u0628",
    midnight: "\u0646",
    noon: "\u0638",
    morning: "\u0635",
    afternoon: "\u0628.\u0638.",
    evening: "\u0639",
    night: "\u0634"
  },
  abbreviated: {
    am: "\u0642.\u0638.",
    pm: "\u0628.\u0638.",
    midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
    noon: "\u0638\u0647\u0631",
    morning: "\u0635\u0628\u062D",
    afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
    evening: "\u0639\u0635\u0631",
    night: "\u0634\u0628"
  },
  wide: {
    am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
    pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
    midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
    noon: "\u0638\u0647\u0631",
    morning: "\u0635\u0628\u062D",
    afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
    evening: "\u0639\u0635\u0631",
    night: "\u0634\u0628"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "\u0642",
    pm: "\u0628",
    midnight: "\u0646",
    noon: "\u0638",
    morning: "\u0635",
    afternoon: "\u0628.\u0638.",
    evening: "\u0639",
    night: "\u0634"
  },
  abbreviated: {
    am: "\u0642.\u0638.",
    pm: "\u0628.\u0638.",
    midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
    noon: "\u0638\u0647\u0631",
    morning: "\u0635\u0628\u062D",
    afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
    evening: "\u0639\u0635\u0631",
    night: "\u0634\u0628"
  },
  wide: {
    am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
    pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
    midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
    noon: "\u0638\u0647\u0631",
    morning: "\u0635\u0628\u062D",
    afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
    evening: "\u0639\u0635\u0631",
    night: "\u0634\u0628"
  }
};
var ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + "-\u0627\u0645";
};
var localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};

// ../../../../../../tmp/date-fns-jalali/locale/_lib/buildMatchFn.mjs
function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;
    const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];
    const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString)) : findKey(parsePatterns, (pattern) => pattern.test(matchedString));
    let value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    const rest = string.slice(matchedString.length);
    return { value, rest };
  };
}
var findKey = function(object, predicate) {
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) {
      return key;
    }
  }
  return;
};
var findIndex = function(array, predicate) {
  for (let key = 0;key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return;
};

// ../../../../../../tmp/date-fns-jalali/locale/_lib/buildMatchPatternFn.mjs
function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult)
      return null;
    const matchedString = matchResult[0];
    const parseResult = string.match(args.parsePattern);
    if (!parseResult)
      return null;
    let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    const rest = string.slice(matchedString.length);
    return { value, rest };
  };
}

// ../../../../../../tmp/date-fns-jalali/locale/fa-IR/_lib/match.mjs
var matchOrdinalNumberPattern = /^(\d+)(-?ام)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?ه\.?|ب\.?\s?ه\.?|ه\.?)/i,
  wide: /^(قبل از هجرت|هجری شمسی|بعد از هجرت)/i
};
var parseEraPatterns = {
  any: [/^قبل/i, /^بعد/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^(ف|Q|س‌م)[1234]/i,
  wide: /^(فصل|quarter|سه‌ماهه) [1234](-ام|ام)?/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^(فر|ار|خر|تی|مر|شه|مه|آب|آذ|دی|به|اس)/i,
  abbreviated: /^(فرو|ارد|خرد|تیر|مرد|شهر|مهر|آبا|آذر|دی|بهم|اسف)/i,
  wide: /^(فروردین|اردیبهشت|خرداد|تیر|مرداد|شهریور|مهر|آبان|آذر|دی|بهمن|اسفند)/i
};
var parseMonthPatterns = {
  narrow: [
    /^فر/i,
    /^ار/i,
    /^خر/i,
    /^تی/i,
    /^مر/i,
    /^شه/i,
    /^مه/i,
    /^آب/i,
    /^آذ/i,
    /^دی/i,
    /^به/i,
    /^اس/i
  ],
  any: [
    /^فر/i,
    /^ار/i,
    /^خر/i,
    /^تی/i,
    /^مر/i,
    /^شه/i,
    /^مه/i,
    /^آب/i,
    /^آذ/i,
    /^دی/i,
    /^به/i,
    /^اس/i
  ]
};
var matchDayPatterns = {
  narrow: /^[شیدسچپج]/i,
  short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
  abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
  wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
};
var parseDayPatterns = {
  narrow: [/^ی/i, /^دو/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
  any: [
    /^(ی|1ش|یکشنبه)/i,
    /^(د|2ش|دوشنبه)/i,
    /^(س|3ش|سه‌شنبه)/i,
    /^(چ|4ش|چهارشنبه)/i,
    /^(پ|5ش|پنجشنبه)/i,
    /^(ج|جمعه)/i,
    /^(ش|شنبه)/i
  ]
};
var matchDayPeriodPatterns = {
  narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
  any: /^(ق.ظ.|ب.ظ.|قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
    pm: /^(ب|ب.ظ.|بعدازظهر)/i,
    midnight: /^(‌نیمه‌شب|ن)/i,
    noon: /^(ظ|ظهر)/i,
    morning: /^(ص|صبح)/i,
    afternoon: /^(ب|ب.ظ.|بعدازظهر)/i,
    evening: /^(ع|عصر)/i,
    night: /^(ش|شب)/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};

// ../../../../../../tmp/date-fns-jalali/locale/fa-IR.mjs
var faIR = {
  code: "fa-IR",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 6,
    firstWeekContainsDate: 1
  }
};
// ../../../../../../tmp/date-fns-jalali/getDayOfYear.mjs
function getDayOfYear(date) {
  const _date = toDate(date);
  const diff = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}

// ../../../../../../tmp/date-fns-jalali/getISOWeek.mjs
function getISOWeek(date) {
  const _date = toDate(date);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);
  return Math.round(diff / millisecondsInWeek) + 1;
}

// ../../../../../../tmp/date-fns-jalali/getWeekYear.mjs
function getWeekYear(date, options) {
  const _date = toDate(date);
  const year = getFullYear(_date);
  const defaultOptions5 = getDefaultOptions();
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions5.firstWeekContainsDate ?? defaultOptions5.locale?.options?.firstWeekContainsDate ?? 1;
  const firstWeekOfNextYear = constructFrom(date, 0);
  setFullYear(firstWeekOfNextYear, year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  const firstWeekOfThisYear = constructFrom(date, 0);
  setFullYear(firstWeekOfThisYear, year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// ../../../../../../tmp/date-fns-jalali/startOfWeekYear.mjs
function startOfWeekYear(date, options) {
  const defaultOptions6 = getDefaultOptions();
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions6.firstWeekContainsDate ?? defaultOptions6.locale?.options?.firstWeekContainsDate ?? 1;
  const year = getWeekYear(date, options);
  const firstWeek = constructFrom(date, 0);
  setFullYear(firstWeek, year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/getWeek.mjs
function getWeek(date, options) {
  const _date = toDate(date);
  const diff = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);
  return Math.round(diff / millisecondsInWeek) + 1;
}

// ../../../../../../tmp/date-fns-jalali/_lib/addLeadingZeros.mjs
function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}

// ../../../../../../tmp/date-fns-jalali/_lib/format/lightFormatters.mjs
var lightFormatters = {
  y(date, token) {
    const signedYear = getFullYear(date);
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  M(date, token) {
    const month = getMonth(date);
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  d(date, token) {
    return addLeadingZeros(getDate(date), token.length);
  },
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  h(date, token) {
    return addLeadingZeros(date.getHours() % 12 || 12, token.length);
  },
  H(date, token) {
    return addLeadingZeros(date.getHours(), token.length);
  },
  m(date, token) {
    return addLeadingZeros(date.getMinutes(), token.length);
  },
  s(date, token) {
    return addLeadingZeros(date.getSeconds(), token.length);
  },
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

// ../../../../../../tmp/date-fns-jalali/_lib/format/formatters.mjs
var formatTimezoneShort = function(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
};
var formatTimezoneWithOptionalMinutes = function(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
};
var formatTimezone = function(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
};
var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters = {
  G: function(date, token, localize3) {
    const era = getFullYear(date) > 0 ? 1 : 0;
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return localize3.era(era, { width: "abbreviated" });
      case "GGGGG":
        return localize3.era(era, { width: "narrow" });
      case "GGGG":
      default:
        return localize3.era(era, { width: "wide" });
    }
  },
  y: function(date, token, localize3) {
    if (token === "yo") {
      const signedYear = getFullYear(date);
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize3.ordinalNumber(year, { unit: "year" });
    }
    return lightFormatters.y(date, token);
  },
  Y: function(date, token, localize3, options) {
    const signedWeekYear = getWeekYear(date, options);
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize3.ordinalNumber(weekYear, { unit: "year" });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  R: function(date, token) {
    const isoWeekYear = getISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  u: function(date, token) {
    const year = getFullYear(date);
    return addLeadingZeros(year, token.length);
  },
  Q: function(date, token, localize3) {
    const quarter = Math.ceil((getMonth(date) + 1) / 3);
    switch (token) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize3.ordinalNumber(quarter, { unit: "quarter" });
      case "QQQ":
        return localize3.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize3.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize3.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  q: function(date, token, localize3) {
    const quarter = Math.ceil((getMonth(date) + 1) / 3);
    switch (token) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize3.ordinalNumber(quarter, { unit: "quarter" });
      case "qqq":
        return localize3.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize3.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize3.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  M: function(date, token, localize3) {
    const month = getMonth(date);
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      case "Mo":
        return localize3.ordinalNumber(month + 1, { unit: "month" });
      case "MMM":
        return localize3.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize3.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize3.month(month, { width: "wide", context: "formatting" });
    }
  },
  L: function(date, token, localize3) {
    const month = getMonth(date);
    switch (token) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize3.ordinalNumber(month + 1, { unit: "month" });
      case "LLL":
        return localize3.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize3.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize3.month(month, { width: "wide", context: "standalone" });
    }
  },
  w: function(date, token, localize3, options) {
    const week = getWeek(date, options);
    if (token === "wo") {
      return localize3.ordinalNumber(week, { unit: "week" });
    }
    return addLeadingZeros(week, token.length);
  },
  I: function(date, token, localize3) {
    const isoWeek = getISOWeek(date);
    if (token === "Io") {
      return localize3.ordinalNumber(isoWeek, { unit: "week" });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  d: function(date, token, localize3) {
    if (token === "do") {
      return localize3.ordinalNumber(getDate(date), { unit: "date" });
    }
    return lightFormatters.d(date, token);
  },
  D: function(date, token, localize3) {
    const dayOfYear = getDayOfYear(date);
    if (token === "Do") {
      return localize3.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  E: function(date, token, localize3) {
    const dayOfWeek = date.getDay();
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return localize3.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize3.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize3.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize3.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  e: function(date, token, localize3, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize3.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize3.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize3.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize3.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize3.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  c: function(date, token, localize3, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      case "co":
        return localize3.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize3.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize3.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize3.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize3.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  i: function(date, token, localize3) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      case "io":
        return localize3.ordinalNumber(isoDayOfWeek, { unit: "day" });
      case "iii":
        return localize3.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize3.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize3.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize3.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  a: function(date, token, localize3) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  b: function(date, token, localize3) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  B: function(date, token, localize3) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  h: function(date, token, localize3) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0)
        hours = 12;
      return localize3.ordinalNumber(hours, { unit: "hour" });
    }
    return lightFormatters.h(date, token);
  },
  H: function(date, token, localize3) {
    if (token === "Ho") {
      return localize3.ordinalNumber(date.getHours(), { unit: "hour" });
    }
    return lightFormatters.H(date, token);
  },
  K: function(date, token, localize3) {
    const hours = date.getHours() % 12;
    if (token === "Ko") {
      return localize3.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  k: function(date, token, localize3) {
    let hours = date.getHours();
    if (hours === 0)
      hours = 24;
    if (token === "ko") {
      return localize3.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  m: function(date, token, localize3) {
    if (token === "mo") {
      return localize3.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }
    return lightFormatters.m(date, token);
  },
  s: function(date, token, localize3) {
    if (token === "so") {
      return localize3.ordinalNumber(date.getSeconds(), { unit: "second" });
    }
    return lightFormatters.s(date, token);
  },
  S: function(date, token) {
    return lightFormatters.S(date, token);
  },
  X: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  x: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  O: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  z: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  t: function(date, token, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  T: function(date, token, _localize) {
    const timestamp = date.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

// ../../../../../../tmp/date-fns-jalali/_lib/format/longFormatters.mjs
var dateLongFormatter = (pattern, formatLong3) => {
  switch (pattern) {
    case "P":
      return formatLong3.date({ width: "short" });
    case "PP":
      return formatLong3.date({ width: "medium" });
    case "PPP":
      return formatLong3.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong3.date({ width: "full" });
  }
};
var timeLongFormatter = (pattern, formatLong3) => {
  switch (pattern) {
    case "p":
      return formatLong3.time({ width: "short" });
    case "pp":
      return formatLong3.time({ width: "medium" });
    case "ppp":
      return formatLong3.time({ width: "long" });
    case "pppp":
    default:
      return formatLong3.time({ width: "full" });
  }
};
var dateTimeLongFormatter = (pattern, formatLong3) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong3);
  }
  let dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong3.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong3.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong3.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong3.dateTime({ width: "full" });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong3)).replace("{{time}}", timeLongFormatter(timePattern, formatLong3));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

// ../../../../../../tmp/date-fns-jalali/_lib/protectedTokens.mjs
function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format, input) {
  const _message = message(token, format, input);
  console.warn(_message);
  if (throwTokens.includes(token))
    throw new RangeError(_message);
}
var message = function(token, format, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
};
var dayOfYearTokenRE = /^D+$/;
var weekYearTokenRE = /^Y+$/;
var throwTokens = ["D", "DD", "YY", "YYYY"];

// ../../../../../../tmp/date-fns-jalali/format.mjs
function format(date, formatStr, options) {
  const defaultOptions7 = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions7.locale ?? faIR;
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions7.firstWeekContainsDate ?? defaultOptions7.locale?.options?.firstWeekContainsDate ?? 1;
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions7.weekStartsOn ?? defaultOptions7.locale?.options?.weekStartsOn ?? 6;
  const originalDate = toDate(date);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  let parts = formatStr.match(longFormattingTokensRegExp).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map((substring) => {
    if (substring === "''") {
      return { isToken: false, value: "'" };
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return { isToken: false, value: cleanEscapedString(substring) };
    }
    if (formatters[firstCharacter]) {
      return { isToken: true, value: substring };
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return { isToken: false, value: substring };
  });
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }
  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale
  };
  return parts.map((part) => {
    if (!part.isToken)
      return part.value;
    const token = part.value;
    if (!options?.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token) || !options?.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, String(date));
    }
    const formatter = formatters[token[0]];
    return formatter(originalDate, token, locale.localize, formatterOptions);
  }).join("");
}
var cleanEscapedString = function(input) {
  const matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
};
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

// ../../../../../../tmp/date-fns-jalali/fp/format.mjs
var format3 = convertToFP(format, 2);
// ../../../../../../tmp/date-fns-jalali/formatDistance.mjs
function formatDistance3(date, baseDate, options) {
  const defaultOptions8 = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions8.locale ?? faIR;
  const minutesInAlmostTwoDays = 2520;
  const comparison = compareAsc(date, baseDate);
  if (isNaN(comparison)) {
    throw new RangeError("Invalid time value");
  }
  const localizeOptions = Object.assign({}, options, {
    addSuffix: options?.addSuffix,
    comparison
  });
  let dateLeft;
  let dateRight;
  if (comparison > 0) {
    dateLeft = toDate(baseDate);
    dateRight = toDate(date);
  } else {
    dateLeft = toDate(date);
    dateRight = toDate(baseDate);
  }
  const seconds = differenceInSeconds(dateRight, dateLeft);
  const offsetInSeconds = (getTimezoneOffsetInMilliseconds(dateRight) - getTimezoneOffsetInMilliseconds(dateLeft)) / 1000;
  const minutes = Math.round((seconds - offsetInSeconds) / 60);
  let months;
  if (minutes < 2) {
    if (options?.includeSeconds) {
      if (seconds < 5) {
        return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
      } else if (seconds < 10) {
        return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
      } else if (seconds < 20) {
        return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
      } else if (seconds < 40) {
        return locale.formatDistance("halfAMinute", 0, localizeOptions);
      } else if (seconds < 60) {
        return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
      } else {
        return locale.formatDistance("xMinutes", 1, localizeOptions);
      }
    } else {
      if (minutes === 0) {
        return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
      } else {
        return locale.formatDistance("xMinutes", minutes, localizeOptions);
      }
    }
  } else if (minutes < 45) {
    return locale.formatDistance("xMinutes", minutes, localizeOptions);
  } else if (minutes < 90) {
    return locale.formatDistance("aboutXHours", 1, localizeOptions);
  } else if (minutes < minutesInDay) {
    const hours = Math.round(minutes / 60);
    return locale.formatDistance("aboutXHours", hours, localizeOptions);
  } else if (minutes < minutesInAlmostTwoDays) {
    return locale.formatDistance("xDays", 1, localizeOptions);
  } else if (minutes < minutesInMonth) {
    const days = Math.round(minutes / minutesInDay);
    return locale.formatDistance("xDays", days, localizeOptions);
  } else if (minutes < minutesInMonth * 2) {
    months = Math.round(minutes / minutesInMonth);
    return locale.formatDistance("aboutXMonths", months, localizeOptions);
  }
  months = differenceInMonths(dateRight, dateLeft);
  if (months < 12) {
    const nearestMonth = Math.round(minutes / minutesInMonth);
    return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
  } else {
    const monthsSinceStartOfYear = months % 12;
    const years = Math.trunc(months / 12);
    if (monthsSinceStartOfYear < 3) {
      return locale.formatDistance("aboutXYears", years, localizeOptions);
    } else if (monthsSinceStartOfYear < 9) {
      return locale.formatDistance("overXYears", years, localizeOptions);
    } else {
      return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
  }
}

// ../../../../../../tmp/date-fns-jalali/fp/formatDistance.mjs
var formatDistance5 = convertToFP(formatDistance3, 2);
// ../../../../../../tmp/date-fns-jalali/formatDistanceStrict.mjs
function formatDistanceStrict(date, baseDate, options) {
  const defaultOptions9 = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions9.locale ?? faIR;
  const comparison = compareAsc(date, baseDate);
  if (isNaN(comparison)) {
    throw new RangeError("Invalid time value");
  }
  const localizeOptions = Object.assign({}, options, {
    addSuffix: options?.addSuffix,
    comparison
  });
  let dateLeft;
  let dateRight;
  if (comparison > 0) {
    dateLeft = toDate(baseDate);
    dateRight = toDate(date);
  } else {
    dateLeft = toDate(date);
    dateRight = toDate(baseDate);
  }
  const roundingMethod = getRoundingMethod(options?.roundingMethod ?? "round");
  const milliseconds = dateRight.getTime() - dateLeft.getTime();
  const minutes = milliseconds / millisecondsInMinute;
  const timezoneOffset = getTimezoneOffsetInMilliseconds(dateRight) - getTimezoneOffsetInMilliseconds(dateLeft);
  const dstNormalizedMinutes = (milliseconds - timezoneOffset) / millisecondsInMinute;
  const defaultUnit = options?.unit;
  let unit;
  if (!defaultUnit) {
    if (minutes < 1) {
      unit = "second";
    } else if (minutes < 60) {
      unit = "minute";
    } else if (minutes < minutesInDay) {
      unit = "hour";
    } else if (dstNormalizedMinutes < minutesInMonth) {
      unit = "day";
    } else if (dstNormalizedMinutes < minutesInYear) {
      unit = "month";
    } else {
      unit = "year";
    }
  } else {
    unit = defaultUnit;
  }
  if (unit === "second") {
    const seconds = roundingMethod(milliseconds / 1000);
    return locale.formatDistance("xSeconds", seconds, localizeOptions);
  } else if (unit === "minute") {
    const roundedMinutes = roundingMethod(minutes);
    return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
  } else if (unit === "hour") {
    const hours = roundingMethod(minutes / 60);
    return locale.formatDistance("xHours", hours, localizeOptions);
  } else if (unit === "day") {
    const days = roundingMethod(dstNormalizedMinutes / minutesInDay);
    return locale.formatDistance("xDays", days, localizeOptions);
  } else if (unit === "month") {
    const months = roundingMethod(dstNormalizedMinutes / minutesInMonth);
    return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
  } else {
    const years = roundingMethod(dstNormalizedMinutes / minutesInYear);
    return locale.formatDistance("xYears", years, localizeOptions);
  }
}

// ../../../../../../tmp/date-fns-jalali/fp/formatDistanceStrict.mjs
var formatDistanceStrict3 = convertToFP(formatDistanceStrict, 2);
// ../../../../../../tmp/date-fns-jalali/fp/formatDistanceStrictWithOptions.mjs
var formatDistanceStrictWithOptions = convertToFP(formatDistanceStrict, 3);
// ../../../../../../tmp/date-fns-jalali/fp/formatDistanceWithOptions.mjs
var formatDistanceWithOptions = convertToFP(formatDistance3, 3);
// ../../../../../../tmp/date-fns-jalali/formatDuration.mjs
function formatDuration(duration, options) {
  const defaultOptions10 = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions10.locale ?? faIR;
  const format4 = options?.format ?? defaultFormat;
  const zero = options?.zero ?? false;
  const delimiter = options?.delimiter ?? " ";
  if (!locale.formatDistance) {
    return "";
  }
  const result = format4.reduce((acc, unit) => {
    const token = `x${unit.replace(/(^.)/, (m) => m.toUpperCase())}`;
    const value = duration[unit];
    if (value !== undefined && (zero || duration[unit])) {
      return acc.concat(locale.formatDistance(token, value));
    }
    return acc;
  }, []).join(delimiter);
  return result;
}
var defaultFormat = [
  "years",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds"
];

// ../../../../../../tmp/date-fns-jalali/fp/formatDuration.mjs
var formatDuration3 = convertToFP(formatDuration, 1);
// ../../../../../../tmp/date-fns-jalali/fp/formatDurationWithOptions.mjs
var formatDurationWithOptions = convertToFP(formatDuration, 2);
// ../../../../../../tmp/date-fns-jalali/formatISO.mjs
function formatISO(date, options) {
  const _date = toDate(date);
  if (isNaN(_date.getTime())) {
    throw new RangeError("Invalid time value");
  }
  const format4 = options?.format ?? "extended";
  const representation = options?.representation ?? "complete";
  let result = "";
  let tzOffset = "";
  const dateDelimiter = format4 === "extended" ? "-" : "";
  const timeDelimiter = format4 === "extended" ? ":" : "";
  if (representation !== "time") {
    const day = addLeadingZeros(_date.getDate(), 2);
    const month = addLeadingZeros(_date.getMonth() + 1, 2);
    const year = addLeadingZeros(_date.getFullYear(), 4);
    result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
  }
  if (representation !== "date") {
    const offset = _date.getTimezoneOffset();
    if (offset !== 0) {
      const absoluteOffset = Math.abs(offset);
      const hourOffset = addLeadingZeros(Math.trunc(absoluteOffset / 60), 2);
      const minuteOffset = addLeadingZeros(absoluteOffset % 60, 2);
      const sign = offset < 0 ? "+" : "-";
      tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
    } else {
      tzOffset = "Z";
    }
    const hour = addLeadingZeros(_date.getHours(), 2);
    const minute = addLeadingZeros(_date.getMinutes(), 2);
    const second = addLeadingZeros(_date.getSeconds(), 2);
    const separator = result === "" ? "" : "T";
    const time = [hour, minute, second].join(timeDelimiter);
    result = `${result}${separator}${time}${tzOffset}`;
  }
  return result;
}

// ../../../../../../tmp/date-fns-jalali/fp/formatISO.mjs
var formatISO3 = convertToFP(formatISO, 1);
// ../../../../../../tmp/date-fns-jalali/formatISO9075.mjs
function formatISO9075(date, options) {
  const _date = toDate(date);
  if (!isValid(_date)) {
    throw new RangeError("Invalid time value");
  }
  const format4 = options?.format ?? "extended";
  const representation = options?.representation ?? "complete";
  let result = "";
  const dateDelimiter = format4 === "extended" ? "-" : "";
  const timeDelimiter = format4 === "extended" ? ":" : "";
  if (representation !== "time") {
    const day = addLeadingZeros(_date.getDate(), 2);
    const month = addLeadingZeros(_date.getMonth() + 1, 2);
    const year = addLeadingZeros(_date.getFullYear(), 4);
    result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
  }
  if (representation !== "date") {
    const hour = addLeadingZeros(_date.getHours(), 2);
    const minute = addLeadingZeros(_date.getMinutes(), 2);
    const second = addLeadingZeros(_date.getSeconds(), 2);
    const separator = result === "" ? "" : " ";
    result = `${result}${separator}${hour}${timeDelimiter}${minute}${timeDelimiter}${second}`;
  }
  return result;
}

// ../../../../../../tmp/date-fns-jalali/fp/formatISO9075.mjs
var formatISO90753 = convertToFP(formatISO9075, 1);
// ../../../../../../tmp/date-fns-jalali/fp/formatISO9075WithOptions.mjs
var formatISO9075WithOptions = convertToFP(formatISO9075, 2);
// ../../../../../../tmp/date-fns-jalali/formatISODuration.mjs
function formatISODuration(duration) {
  const {
    years = 0,
    months = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  } = duration;
  return `P${years}Y${months}M${days}DT${hours}H${minutes}M${seconds}S`;
}

// ../../../../../../tmp/date-fns-jalali/fp/formatISODuration.mjs
var formatISODuration3 = convertToFP(formatISODuration, 1);
// ../../../../../../tmp/date-fns-jalali/fp/formatISOWithOptions.mjs
var formatISOWithOptions = convertToFP(formatISO, 2);
// ../../../../../../tmp/date-fns-jalali/formatRFC3339.mjs
function formatRFC3339(date, options) {
  const _date = toDate(date);
  if (!isValid(_date)) {
    throw new RangeError("Invalid time value");
  }
  const fractionDigits = options?.fractionDigits ?? 0;
  const day = addLeadingZeros(_date.getDate(), 2);
  const month = addLeadingZeros(_date.getMonth() + 1, 2);
  const year = _date.getFullYear();
  const hour = addLeadingZeros(_date.getHours(), 2);
  const minute = addLeadingZeros(_date.getMinutes(), 2);
  const second = addLeadingZeros(_date.getSeconds(), 2);
  let fractionalSecond = "";
  if (fractionDigits > 0) {
    const milliseconds = _date.getMilliseconds();
    const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, fractionDigits - 3));
    fractionalSecond = "." + addLeadingZeros(fractionalSeconds, fractionDigits);
  }
  let offset = "";
  const tzOffset = _date.getTimezoneOffset();
  if (tzOffset !== 0) {
    const absoluteOffset = Math.abs(tzOffset);
    const hourOffset = addLeadingZeros(Math.trunc(absoluteOffset / 60), 2);
    const minuteOffset = addLeadingZeros(absoluteOffset % 60, 2);
    const sign = tzOffset < 0 ? "+" : "-";
    offset = `${sign}${hourOffset}:${minuteOffset}`;
  } else {
    offset = "Z";
  }
  return `${year}-${month}-${day}T${hour}:${minute}:${second}${fractionalSecond}${offset}`;
}

// ../../../../../../tmp/date-fns-jalali/fp/formatRFC3339.mjs
var formatRFC33393 = convertToFP(formatRFC3339, 1);
// ../../../../../../tmp/date-fns-jalali/fp/formatRFC3339WithOptions.mjs
var formatRFC3339WithOptions = convertToFP(formatRFC3339, 2);
// ../../../../../../tmp/date-fns-jalali/formatRFC7231.mjs
function formatRFC7231(date) {
  const _date = toDate(date);
  if (!isValid(_date)) {
    throw new RangeError("Invalid time value");
  }
  const dayName = days[_date.getUTCDay()];
  const dayOfMonth = addLeadingZeros(_date.getUTCDate(), 2);
  const monthName = months[_date.getUTCMonth()];
  const year = _date.getUTCFullYear();
  const hour = addLeadingZeros(_date.getUTCHours(), 2);
  const minute = addLeadingZeros(_date.getUTCMinutes(), 2);
  const second = addLeadingZeros(_date.getUTCSeconds(), 2);
  return `${dayName}, ${dayOfMonth} ${monthName} ${year} ${hour}:${minute}:${second} GMT`;
}
var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
var months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

// ../../../../../../tmp/date-fns-jalali/fp/formatRFC7231.mjs
var formatRFC72313 = convertToFP(formatRFC7231, 1);
// ../../../../../../tmp/date-fns-jalali/formatRelative.mjs
function formatRelative3(date, baseDate, options) {
  const _date = toDate(date);
  const _baseDate = toDate(baseDate);
  const defaultOptions11 = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions11.locale ?? faIR;
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions11.weekStartsOn ?? defaultOptions11.locale?.options?.weekStartsOn ?? 0;
  const diff = differenceInCalendarDays(_date, _baseDate);
  if (isNaN(diff)) {
    throw new RangeError("Invalid time value");
  }
  let token;
  if (diff < -6) {
    token = "other";
  } else if (diff < -1) {
    token = "lastWeek";
  } else if (diff < 0) {
    token = "yesterday";
  } else if (diff < 1) {
    token = "today";
  } else if (diff < 2) {
    token = "tomorrow";
  } else if (diff < 7) {
    token = "nextWeek";
  } else {
    token = "other";
  }
  const formatStr = locale.formatRelative(token, _date, _baseDate, {
    locale,
    weekStartsOn
  });
  return format(_date, formatStr, { locale, weekStartsOn });
}

// ../../../../../../tmp/date-fns-jalali/fp/formatRelative.mjs
var formatRelative5 = convertToFP(formatRelative3, 2);
// ../../../../../../tmp/date-fns-jalali/fp/formatRelativeWithOptions.mjs
var formatRelativeWithOptions = convertToFP(formatRelative3, 3);
// ../../../../../../tmp/date-fns-jalali/fp/formatWithOptions.mjs
var formatWithOptions = convertToFP(format, 3);
// ../../../../../../tmp/date-fns-jalali/fromUnixTime.mjs
function fromUnixTime(unixTime) {
  return toDate(unixTime * 1000);
}

// ../../../../../../tmp/date-fns-jalali/fp/fromUnixTime.mjs
var fromUnixTime3 = convertToFP(fromUnixTime, 1);
// ../../../../../../tmp/date-fns-jalali/getDate.mjs
function getDate13(date) {
  const _date = toDate(date);
  const dayOfMonth = getDate(_date);
  return dayOfMonth;
}

// ../../../../../../tmp/date-fns-jalali/fp/getDate.mjs
var getDate15 = convertToFP(getDate13, 1);
// ../../../../../../tmp/date-fns-jalali/getDay.mjs
function getDay(date) {
  const _date = toDate(date);
  const day = _date.getDay();
  return day;
}

// ../../../../../../tmp/date-fns-jalali/fp/getDay.mjs
var getDay3 = convertToFP(getDay, 1);
// ../../../../../../tmp/date-fns-jalali/fp/getDayOfYear.mjs
var getDayOfYear4 = convertToFP(getDayOfYear, 1);
// ../../../../../../tmp/date-fns-jalali/getDaysInMonth.mjs
function getDaysInMonth(date) {
  const _date = toDate(date);
  const year = getFullYear(_date);
  const monthIndex = getMonth(_date);
  const lastDayOfMonth = constructFrom(date, 0);
  setFullYear(lastDayOfMonth, year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return getDate(lastDayOfMonth);
}

// ../../../../../../tmp/date-fns-jalali/fp/getDaysInMonth.mjs
var getDaysInMonth3 = convertToFP(getDaysInMonth, 1);
// ../../../../../../tmp/date-fns-jalali/_core/isLeapYear.mjs
function isLeapYear(year) {
  return isLeapJalaliYear(year);
}

// ../../../../../../tmp/date-fns-jalali/isLeapYear.mjs
function isLeapYear3(date) {
  const _date = toDate(date);
  const year = getFullYear(_date);
  return isLeapYear(year);
}

// ../../../../../../tmp/date-fns-jalali/getDaysInYear.mjs
function getDaysInYear(date) {
  const _date = toDate(date);
  if (String(newDate(_date)) === "Invalid Date") {
    return NaN;
  }
  return isLeapYear3(_date) ? 366 : 365;
}

// ../../../../../../tmp/date-fns-jalali/fp/getDaysInYear.mjs
var getDaysInYear3 = convertToFP(getDaysInYear, 1);
// ../../../../../../tmp/date-fns-jalali/getDecade.mjs
function getDecade(date) {
  const _date = toDate(date);
  const year = getFullYear(_date);
  const decade = Math.floor(year / 10) * 10;
  return decade;
}

// ../../../../../../tmp/date-fns-jalali/fp/getDecade.mjs
var getDecade3 = convertToFP(getDecade, 1);
// ../../../../../../tmp/date-fns-jalali/getHours.mjs
function getHours(date) {
  const _date = toDate(date);
  const hours = _date.getHours();
  return hours;
}

// ../../../../../../tmp/date-fns-jalali/fp/getHours.mjs
var getHours3 = convertToFP(getHours, 1);
// ../../../../../../tmp/date-fns-jalali/getISODay.mjs
function getISODay(date) {
  const _date = toDate(date);
  let day = _date.getDay();
  if (day === 0) {
    day = 7;
  }
  return day;
}

// ../../../../../../tmp/date-fns-jalali/fp/getISODay.mjs
var getISODay3 = convertToFP(getISODay, 1);
// ../../../../../../tmp/date-fns-jalali/fp/getISOWeek.mjs
var getISOWeek4 = convertToFP(getISOWeek, 1);
// ../../../../../../tmp/date-fns-jalali/fp/getISOWeekYear.mjs
var getISOWeekYear8 = convertToFP(getISOWeekYear, 1);
// ../../../../../../tmp/date-fns-jalali/getISOWeeksInYear.mjs
function getISOWeeksInYear(date) {
  const thisYear = startOfISOWeekYear(date);
  const nextYear = startOfISOWeekYear(addWeeks(thisYear, 60));
  const diff = +nextYear - +thisYear;
  return Math.round(diff / millisecondsInWeek);
}

// ../../../../../../tmp/date-fns-jalali/fp/getISOWeeksInYear.mjs
var getISOWeeksInYear3 = convertToFP(getISOWeeksInYear, 1);
// ../../../../../../tmp/date-fns-jalali/getMilliseconds.mjs
function getMilliseconds(date) {
  const _date = toDate(date);
  const milliseconds = _date.getMilliseconds();
  return milliseconds;
}

// ../../../../../../tmp/date-fns-jalali/fp/getMilliseconds.mjs
var getMilliseconds3 = convertToFP(getMilliseconds, 1);
// ../../../../../../tmp/date-fns-jalali/getMinutes.mjs
function getMinutes(date) {
  const _date = toDate(date);
  const minutes = _date.getMinutes();
  return minutes;
}

// ../../../../../../tmp/date-fns-jalali/fp/getMinutes.mjs
var getMinutes3 = convertToFP(getMinutes, 1);
// ../../../../../../tmp/date-fns-jalali/getMonth.mjs
function getMonth15(date) {
  const _date = toDate(date);
  const month = getMonth(_date);
  return month;
}

// ../../../../../../tmp/date-fns-jalali/fp/getMonth.mjs
var getMonth17 = convertToFP(getMonth15, 1);
// ../../../../../../tmp/date-fns-jalali/getOverlappingDaysInIntervals.mjs
function getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
  const [leftStart, leftEnd] = [
    +toDate(intervalLeft.start),
    +toDate(intervalLeft.end)
  ].sort((a, b) => a - b);
  const [rightStart, rightEnd] = [
    +toDate(intervalRight.start),
    +toDate(intervalRight.end)
  ].sort((a, b) => a - b);
  const isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
  if (!isOverlapping)
    return 0;
  const overlapLeft = rightStart < leftStart ? leftStart : rightStart;
  const left = overlapLeft - getTimezoneOffsetInMilliseconds(overlapLeft);
  const overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
  const right = overlapRight - getTimezoneOffsetInMilliseconds(overlapRight);
  return Math.ceil((right - left) / millisecondsInDay);
}

// ../../../../../../tmp/date-fns-jalali/fp/getOverlappingDaysInIntervals.mjs
var getOverlappingDaysInIntervals3 = convertToFP(getOverlappingDaysInIntervals, 2);
// ../../../../../../tmp/date-fns-jalali/fp/getQuarter.mjs
var getQuarter4 = convertToFP(getQuarter, 1);
// ../../../../../../tmp/date-fns-jalali/getSeconds.mjs
function getSeconds(date) {
  const _date = toDate(date);
  const seconds = _date.getSeconds();
  return seconds;
}

// ../../../../../../tmp/date-fns-jalali/fp/getSeconds.mjs
var getSeconds3 = convertToFP(getSeconds, 1);
// ../../../../../../tmp/date-fns-jalali/getTime.mjs
function getTime(date) {
  const _date = toDate(date);
  const timestamp = _date.getTime();
  return timestamp;
}

// ../../../../../../tmp/date-fns-jalali/fp/getTime.mjs
var getTime3 = convertToFP(getTime, 1);
// ../../../../../../tmp/date-fns-jalali/getUnixTime.mjs
function getUnixTime(date) {
  return Math.trunc(+toDate(date) / 1000);
}

// ../../../../../../tmp/date-fns-jalali/fp/getUnixTime.mjs
var getUnixTime3 = convertToFP(getUnixTime, 1);
// ../../../../../../tmp/date-fns-jalali/fp/getWeek.mjs
var getWeek4 = convertToFP(getWeek, 1);
// ../../../../../../tmp/date-fns-jalali/getWeekOfMonth.mjs
function getWeekOfMonth(date, options) {
  const defaultOptions12 = getDefaultOptions();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions12.weekStartsOn ?? defaultOptions12.locale?.options?.weekStartsOn ?? 6;
  const currentDayOfMonth = getDate13(date);
  if (isNaN(currentDayOfMonth))
    return NaN;
  const startWeekDay = getDay(startOfMonth(date));
  let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
  if (lastDayOfFirstWeek <= 0)
    lastDayOfFirstWeek += 7;
  const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
  return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}

// ../../../../../../tmp/date-fns-jalali/fp/getWeekOfMonth.mjs
var getWeekOfMonth3 = convertToFP(getWeekOfMonth, 1);
// ../../../../../../tmp/date-fns-jalali/fp/getWeekOfMonthWithOptions.mjs
var getWeekOfMonthWithOptions = convertToFP(getWeekOfMonth, 2);
// ../../../../../../tmp/date-fns-jalali/fp/getWeekWithOptions.mjs
var getWeekWithOptions = convertToFP(getWeek, 2);
// ../../../../../../tmp/date-fns-jalali/fp/getWeekYear.mjs
var getWeekYear5 = convertToFP(getWeekYear, 1);
// ../../../../../../tmp/date-fns-jalali/fp/getWeekYearWithOptions.mjs
var getWeekYearWithOptions = convertToFP(getWeekYear, 2);
// ../../../../../../tmp/date-fns-jalali/lastDayOfMonth.mjs
function lastDayOfMonth(date) {
  const _date = toDate(date);
  const month = getMonth(_date);
  setFullYear(_date, getFullYear(_date), month + 1, 0);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/getWeeksInMonth.mjs
function getWeeksInMonth(date, options) {
  return differenceInCalendarWeeks(lastDayOfMonth(date), startOfMonth(date), options) + 1;
}

// ../../../../../../tmp/date-fns-jalali/fp/getWeeksInMonth.mjs
var getWeeksInMonth3 = convertToFP(getWeeksInMonth, 1);
// ../../../../../../tmp/date-fns-jalali/fp/getWeeksInMonthWithOptions.mjs
var getWeeksInMonthWithOptions = convertToFP(getWeeksInMonth, 2);
// ../../../../../../tmp/date-fns-jalali/getYear.mjs
function getYear(date) {
  return getFullYear(toDate(date));
}

// ../../../../../../tmp/date-fns-jalali/fp/getYear.mjs
var getYear3 = convertToFP(getYear, 1);
// ../../../../../../tmp/date-fns-jalali/hoursToMilliseconds.mjs
function hoursToMilliseconds(hours) {
  return Math.trunc(hours * millisecondsInHour);
}

// ../../../../../../tmp/date-fns-jalali/fp/hoursToMilliseconds.mjs
var hoursToMilliseconds3 = convertToFP(hoursToMilliseconds, 1);
// ../../../../../../tmp/date-fns-jalali/hoursToMinutes.mjs
function hoursToMinutes(hours) {
  return Math.trunc(hours * minutesInHour);
}

// ../../../../../../tmp/date-fns-jalali/fp/hoursToMinutes.mjs
var hoursToMinutes3 = convertToFP(hoursToMinutes, 1);
// ../../../../../../tmp/date-fns-jalali/hoursToSeconds.mjs
function hoursToSeconds(hours) {
  return Math.trunc(hours * secondsInHour);
}

// ../../../../../../tmp/date-fns-jalali/fp/hoursToSeconds.mjs
var hoursToSeconds3 = convertToFP(hoursToSeconds, 1);
// ../../../../../../tmp/date-fns-jalali/interval.mjs
function interval(start, end, options) {
  const _start = toDate(start);
  if (isNaN(+_start))
    throw new TypeError("Start date is invalid");
  const _end = toDate(end);
  if (isNaN(+_end))
    throw new TypeError("End date is invalid");
  if (options?.assertPositive && +_start > +_end)
    throw new TypeError("End date must be after start date");
  return { start: _start, end: _end };
}

// ../../../../../../tmp/date-fns-jalali/fp/interval.mjs
var interval3 = convertToFP(interval, 2);
// ../../../../../../tmp/date-fns-jalali/intervalToDuration.mjs
function intervalToDuration(interval4) {
  const start = toDate(interval4.start);
  const end = toDate(interval4.end);
  const duration = {};
  const years = differenceInYears(end, start);
  if (years)
    duration.years = years;
  const remainingMonths = add(start, { years: duration.years });
  const months2 = differenceInMonths(end, remainingMonths);
  if (months2)
    duration.months = months2;
  const remainingDays = add(remainingMonths, { months: duration.months });
  const days2 = differenceInDays(end, remainingDays);
  if (days2)
    duration.days = days2;
  const remainingHours = add(remainingDays, { days: duration.days });
  const hours = differenceInHours(end, remainingHours);
  if (hours)
    duration.hours = hours;
  const remainingMinutes = add(remainingHours, { hours: duration.hours });
  const minutes = differenceInMinutes(end, remainingMinutes);
  if (minutes)
    duration.minutes = minutes;
  const remainingSeconds = add(remainingMinutes, { minutes: duration.minutes });
  const seconds = differenceInSeconds(end, remainingSeconds);
  if (seconds)
    duration.seconds = seconds;
  return duration;
}

// ../../../../../../tmp/date-fns-jalali/fp/intervalToDuration.mjs
var intervalToDuration3 = convertToFP(intervalToDuration, 1);
// ../../../../../../tmp/date-fns-jalali/fp/intervalWithOptions.mjs
var intervalWithOptions = convertToFP(interval, 3);
// ../../../../../../tmp/date-fns-jalali/intlFormat.mjs
function intlFormat(date, formatOrLocale, localeOptions) {
  let formatOptions;
  if (isFormatOptions(formatOrLocale)) {
    formatOptions = formatOrLocale;
  } else {
    localeOptions = formatOrLocale;
  }
  return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format(toDate(date));
}
var isFormatOptions = function(opts) {
  return opts !== undefined && !("locale" in opts);
};

// ../../../../../../tmp/date-fns-jalali/fp/intlFormat.mjs
var intlFormat3 = convertToFP(intlFormat, 3);
// ../../../../../../tmp/date-fns-jalali/intlFormatDistance.mjs
function intlFormatDistance(date, baseDate, options) {
  let value = 0;
  let unit;
  const dateLeft = toDate(date);
  const dateRight = toDate(baseDate);
  if (!options?.unit) {
    const diffInSeconds = differenceInSeconds(dateLeft, dateRight);
    if (Math.abs(diffInSeconds) < secondsInMinute) {
      value = differenceInSeconds(dateLeft, dateRight);
      unit = "second";
    } else if (Math.abs(diffInSeconds) < secondsInHour) {
      value = differenceInMinutes(dateLeft, dateRight);
      unit = "minute";
    } else if (Math.abs(diffInSeconds) < secondsInDay && Math.abs(differenceInCalendarDays(dateLeft, dateRight)) < 1) {
      value = differenceInHours(dateLeft, dateRight);
      unit = "hour";
    } else if (Math.abs(diffInSeconds) < secondsInWeek && (value = differenceInCalendarDays(dateLeft, dateRight)) && Math.abs(value) < 7) {
      unit = "day";
    } else if (Math.abs(diffInSeconds) < secondsInMonth) {
      value = differenceInCalendarWeeks(dateLeft, dateRight);
      unit = "week";
    } else if (Math.abs(diffInSeconds) < secondsInQuarter) {
      value = differenceInCalendarMonths(dateLeft, dateRight);
      unit = "month";
    } else if (Math.abs(diffInSeconds) < secondsInYear) {
      if (differenceInCalendarQuarters(dateLeft, dateRight) < 4) {
        value = differenceInCalendarQuarters(dateLeft, dateRight);
        unit = "quarter";
      } else {
        value = differenceInCalendarYears(dateLeft, dateRight);
        unit = "year";
      }
    } else {
      value = differenceInCalendarYears(dateLeft, dateRight);
      unit = "year";
    }
  } else {
    unit = options?.unit;
    if (unit === "second") {
      value = differenceInSeconds(dateLeft, dateRight);
    } else if (unit === "minute") {
      value = differenceInMinutes(dateLeft, dateRight);
    } else if (unit === "hour") {
      value = differenceInHours(dateLeft, dateRight);
    } else if (unit === "day") {
      value = differenceInCalendarDays(dateLeft, dateRight);
    } else if (unit === "week") {
      value = differenceInCalendarWeeks(dateLeft, dateRight);
    } else if (unit === "month") {
      value = differenceInCalendarMonths(dateLeft, dateRight);
    } else if (unit === "quarter") {
      value = differenceInCalendarQuarters(dateLeft, dateRight);
    } else if (unit === "year") {
      value = differenceInCalendarYears(dateLeft, dateRight);
    }
  }
  const rtf = new Intl.RelativeTimeFormat(options?.locale, {
    localeMatcher: options?.localeMatcher,
    numeric: options?.numeric || "auto",
    style: options?.style
  });
  return rtf.format(value, unit);
}

// ../../../../../../tmp/date-fns-jalali/fp/intlFormatDistance.mjs
var intlFormatDistance3 = convertToFP(intlFormatDistance, 2);
// ../../../../../../tmp/date-fns-jalali/fp/intlFormatDistanceWithOptions.mjs
var intlFormatDistanceWithOptions = convertToFP(intlFormatDistance, 3);
// ../../../../../../tmp/date-fns-jalali/isAfter.mjs
function isAfter(date, dateToCompare) {
  const _date = toDate(date);
  const _dateToCompare = toDate(dateToCompare);
  return _date.getTime() > _dateToCompare.getTime();
}

// ../../../../../../tmp/date-fns-jalali/fp/isAfter.mjs
var isAfter3 = convertToFP(isAfter, 2);
// ../../../../../../tmp/date-fns-jalali/isBefore.mjs
function isBefore(date, dateToCompare) {
  const _date = toDate(date);
  const _dateToCompare = toDate(dateToCompare);
  return +_date < +_dateToCompare;
}

// ../../../../../../tmp/date-fns-jalali/fp/isBefore.mjs
var isBefore3 = convertToFP(isBefore, 2);
// ../../../../../../tmp/date-fns-jalali/fp/isDate.mjs
var isDate4 = convertToFP(isDate, 1);
// ../../../../../../tmp/date-fns-jalali/isEqual.mjs
function isEqual(leftDate, rightDate) {
  const _dateLeft = toDate(leftDate);
  const _dateRight = toDate(rightDate);
  return +_dateLeft === +_dateRight;
}

// ../../../../../../tmp/date-fns-jalali/fp/isEqual.mjs
var isEqual3 = convertToFP(isEqual, 2);
// ../../../../../../tmp/date-fns-jalali/isExists.mjs
function isExists(year, month, day) {
  const date = newDate(year, month, day);
  return getFullYear(date) === year && getMonth(date) === month && getDate(date) === day;
}

// ../../../../../../tmp/date-fns-jalali/fp/isExists.mjs
var isExists3 = convertToFP(isExists, 3);
// ../../../../../../tmp/date-fns-jalali/isFirstDayOfMonth.mjs
function isFirstDayOfMonth(date) {
  return getDate(toDate(date)) === 1;
}

// ../../../../../../tmp/date-fns-jalali/fp/isFirstDayOfMonth.mjs
var isFirstDayOfMonth3 = convertToFP(isFirstDayOfMonth, 1);
// ../../../../../../tmp/date-fns-jalali/isFriday.mjs
function isFriday(date) {
  return toDate(date).getDay() === 5;
}

// ../../../../../../tmp/date-fns-jalali/fp/isFriday.mjs
var isFriday3 = convertToFP(isFriday, 1);
// ../../../../../../tmp/date-fns-jalali/fp/isLastDayOfMonth.mjs
var isLastDayOfMonth4 = convertToFP(isLastDayOfMonth, 1);
// ../../../../../../tmp/date-fns-jalali/fp/isLeapYear.mjs
var isLeapYear6 = convertToFP(isLeapYear3, 1);
// ../../../../../../tmp/date-fns-jalali/getDefaultOptions.mjs
function getDefaultOptions2() {
  return Object.assign({}, getDefaultOptions());
}

// ../../../../../../tmp/date-fns-jalali/transpose.mjs
function transpose(fromDate, constructor) {
  const date = constructor instanceof Date ? constructFrom(constructor, 0) : new constructor(0);
  setFullYear(date, getFullYear(fromDate), getMonth(fromDate), getDate(fromDate));
  date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
  return date;
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/Setter.mjs
var TIMEZONE_UNIT_PRIORITY = 10;

class Setter {
  subPriority = 0;
  validate(_utcDate, _options) {
    return true;
  }
}

class ValueSetter extends Setter {
  constructor(value, validateValue, setValue, priority, subPriority) {
    super();
    this.value = value;
    this.validateValue = validateValue;
    this.setValue = setValue;
    this.priority = priority;
    if (subPriority) {
      this.subPriority = subPriority;
    }
  }
  validate(date, options) {
    return this.validateValue(date, this.value, options);
  }
  set(date, flags, options) {
    return this.setValue(date, flags, this.value, options);
  }
}

class DateToSystemTimezoneSetter extends Setter {
  priority = TIMEZONE_UNIT_PRIORITY;
  subPriority = -1;
  set(date, flags) {
    if (flags.timestampIsSet)
      return date;
    return constructFrom(date, transpose(date, Date));
  }
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/Parser.mjs
class Parser {
  run(dateString, token, match3, options) {
    const result = this.parse(dateString, token, match3, options);
    if (!result) {
      return null;
    }
    return {
      setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
      rest: result.rest
    };
  }
  validate(_utcDate, _value, _options) {
    return true;
  }
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/EraParser.mjs
class EraParser extends Parser {
  priority = 140;
  parse(dateString, token, match3) {
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return match3.era(dateString, { width: "abbreviated" }) || match3.era(dateString, { width: "narrow" });
      case "GGGGG":
        return match3.era(dateString, { width: "narrow" });
      case "GGGG":
      default:
        return match3.era(dateString, { width: "wide" }) || match3.era(dateString, { width: "abbreviated" }) || match3.era(dateString, { width: "narrow" });
    }
  }
  set(date, flags, value) {
    flags.era = value;
    setFullYear(date, value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["R", "u", "t", "T"];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/constants.mjs
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  date: /^(3[0-1]|[0-2]?\d)/,
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  week: /^(5[0-3]|[0-4]?\d)/,
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  hour11h: /^(1[0-1]|0?\d)/,
  hour12h: /^(1[0-2]|0?\d)/,
  minute: /^[0-5]?\d/,
  second: /^[0-5]?\d/,
  singleDigit: /^\d/,
  twoDigits: /^\d{1,2}/,
  threeDigits: /^\d{1,3}/,
  fourDigits: /^\d{1,4}/,
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  twoDigitsSigned: /^-?\d{1,2}/,
  threeDigitsSigned: /^-?\d{1,3}/,
  fourDigitsSigned: /^-?\d{1,4}/
};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

// ../../../../../../tmp/date-fns-jalali/parse/_lib/utils.mjs
function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  const sign = matchResult[1] === "+" ? 1 : -1;
  const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  const isCommonEra = currentYear > 0;
  const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  let result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    const rangeEnd = absCurrentYear + 50;
    const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
    const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return isLeapYear3(newDate(year, 0));
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/YearParser.mjs
class YearParser extends Parser {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];
  parse(dateString, token, match3) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "yy"
    });
    switch (token) {
      case "y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "yo":
        return mapValue(match3.ordinalNumber(dateString, {
          unit: "year"
        }), valueCallback);
      default:
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }
  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }
  set(date, flags, value) {
    const currentYear = getFullYear(date);
    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
      setFullYear(date, normalizedTwoDigitYear, 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    }
    const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    setFullYear(date, year, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/LocalWeekYearParser.mjs
class LocalWeekYearParser extends Parser {
  priority = 130;
  parse(dateString, token, match3) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "YY"
    });
    switch (token) {
      case "Y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "Yo":
        return mapValue(match3.ordinalNumber(dateString, {
          unit: "year"
        }), valueCallback);
      default:
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }
  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }
  set(date, flags, value, options) {
    const currentYear = getWeekYear(date, options);
    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
      setFullYear(date, normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
      date.setHours(0, 0, 0, 0);
      return startOfWeek(date, options);
    }
    const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    setFullYear(date, year, 0, options.firstWeekContainsDate);
    date.setHours(0, 0, 0, 0);
    return startOfWeek(date, options);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/ISOWeekYearParser.mjs
class ISOWeekYearParser extends Parser {
  priority = 130;
  parse(dateString, token) {
    if (token === "R") {
      return parseNDigitsSigned(4, dateString);
    }
    return parseNDigitsSigned(token.length, dateString);
  }
  set(date, _flags, value) {
    const firstWeekOfYear = constructFrom(date, 0);
    setFullYear(firstWeekOfYear, value, 0, 4);
    firstWeekOfYear.setHours(0, 0, 0, 0);
    return startOfISOWeek(firstWeekOfYear);
  }
  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/ExtendedYearParser.mjs
class ExtendedYearParser extends Parser {
  priority = 130;
  parse(dateString, token) {
    if (token === "u") {
      return parseNDigitsSigned(4, dateString);
    }
    return parseNDigitsSigned(token.length, dateString);
  }
  set(date, _flags, value) {
    setFullYear(date, value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/QuarterParser.mjs
class QuarterParser extends Parser {
  priority = 120;
  parse(dateString, token, match3) {
    switch (token) {
      case "Q":
      case "QQ":
        return parseNDigits(token.length, dateString);
      case "Qo":
        return match3.ordinalNumber(dateString, { unit: "quarter" });
      case "QQQ":
        return match3.quarter(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return match3.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return match3.quarter(dateString, {
          width: "wide",
          context: "formatting"
        }) || match3.quarter(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 4;
  }
  set(date, _flags, value) {
    setMonth(date, (value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/StandAloneQuarterParser.mjs
class StandAloneQuarterParser extends Parser {
  priority = 120;
  parse(dateString, token, match3) {
    switch (token) {
      case "q":
      case "qq":
        return parseNDigits(token.length, dateString);
      case "qo":
        return match3.ordinalNumber(dateString, { unit: "quarter" });
      case "qqq":
        return match3.quarter(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match3.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return match3.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return match3.quarter(dateString, {
          width: "wide",
          context: "standalone"
        }) || match3.quarter(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match3.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 4;
  }
  set(date, _flags, value) {
    setMonth(date, (value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/MonthParser.mjs
class MonthParser extends Parser {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
  priority = 110;
  parse(dateString, token, match3) {
    const valueCallback = (value) => value - 1;
    switch (token) {
      case "M":
        return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
      case "MM":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      case "Mo":
        return mapValue(match3.ordinalNumber(dateString, {
          unit: "month"
        }), valueCallback);
      case "MMM":
        return match3.month(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.month(dateString, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return match3.month(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return match3.month(dateString, { width: "wide", context: "formatting" }) || match3.month(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.month(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    setMonth(date, value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/StandAloneMonthParser.mjs
class StandAloneMonthParser extends Parser {
  priority = 110;
  parse(dateString, token, match3) {
    const valueCallback = (value) => value - 1;
    switch (token) {
      case "L":
        return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
      case "LL":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      case "Lo":
        return mapValue(match3.ordinalNumber(dateString, {
          unit: "month"
        }), valueCallback);
      case "LLL":
        return match3.month(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match3.month(dateString, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return match3.month(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return match3.month(dateString, { width: "wide", context: "standalone" }) || match3.month(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match3.month(dateString, { width: "narrow", context: "standalone" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    setMonth(date, value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}

// ../../../../../../tmp/date-fns-jalali/setWeek.mjs
function setWeek(date, week, options) {
  const _date = toDate(date);
  const diff = getWeek(_date, options) - week;
  setDate(_date, getDate(_date) - diff * 7);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/LocalWeekParser.mjs
class LocalWeekParser extends Parser {
  priority = 100;
  parse(dateString, token, match3) {
    switch (token) {
      case "w":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "wo":
        return match3.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 53;
  }
  set(date, _flags, value, options) {
    return startOfWeek(setWeek(date, value, options), options);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}

// ../../../../../../tmp/date-fns-jalali/setISOWeek.mjs
function setISOWeek(date, week) {
  const _date = toDate(date);
  const diff = getISOWeek(_date) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/ISOWeekParser.mjs
class ISOWeekParser extends Parser {
  priority = 100;
  parse(dateString, token, match3) {
    switch (token) {
      case "I":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "Io":
        return match3.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 53;
  }
  set(date, _flags, value) {
    return startOfISOWeek(setISOWeek(date, value));
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/DateParser.mjs
var DAYS_IN_MONTH = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];
var DAYS_IN_MONTH_LEAP_YEAR = [
  31,
  31,
  31,
  31,
  31,
  31,
  30,
  30,
  30,
  30,
  30,
  30
];

class DateParser extends Parser {
  priority = 90;
  subPriority = 1;
  parse(dateString, token, match3) {
    switch (token) {
      case "d":
        return parseNumericPattern(numericPatterns.date, dateString);
      case "do":
        return match3.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(date, value) {
    const year = getFullYear(date);
    const isLeapYear8 = isLeapYearIndex(year);
    const month = getMonth(date);
    if (isLeapYear8) {
      return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
    } else {
      return value >= 1 && value <= DAYS_IN_MONTH[month];
    }
  }
  set(date, _flags, value) {
    setDate(date, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/DayOfYearParser.mjs
class DayOfYearParser extends Parser {
  priority = 90;
  subpriority = 1;
  parse(dateString, token, match3) {
    switch (token) {
      case "D":
      case "DD":
        return parseNumericPattern(numericPatterns.dayOfYear, dateString);
      case "Do":
        return match3.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(date, value) {
    const year = getFullYear(date);
    const isLeapYear8 = isLeapYearIndex(year);
    if (isLeapYear8) {
      return value >= 1 && value <= 366;
    } else {
      return value >= 1 && value <= 365;
    }
  }
  set(date, _flags, value) {
    setMonth(date, 0, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}

// ../../../../../../tmp/date-fns-jalali/setDay.mjs
function setDay(date, day, options) {
  const defaultOptions14 = getDefaultOptions();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions14.weekStartsOn ?? defaultOptions14.locale?.options?.weekStartsOn ?? 6;
  const _date = toDate(date);
  const currentDay = _date.getDay();
  const remainder = day % 7;
  const dayIndex = (remainder + 7) % 7;
  const delta = 7 - weekStartsOn;
  const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
  return addDays(_date, diff);
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/DayParser.mjs
class DayParser extends Parser {
  priority = 90;
  parse(dateString, token, match3) {
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return match3.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.day(dateString, { width: "short", context: "formatting" }) || match3.day(dateString, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return match3.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return match3.day(dateString, { width: "short", context: "formatting" }) || match3.day(dateString, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return match3.day(dateString, { width: "wide", context: "formatting" }) || match3.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.day(dateString, { width: "short", context: "formatting" }) || match3.day(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/LocalDayParser.mjs
class LocalDayParser extends Parser {
  priority = 90;
  parse(dateString, token, match3, options) {
    const valueCallback = (value) => {
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return (value + options.weekStartsOn + 6 + 1) % 7 + wholeWeekDays;
    };
    switch (token) {
      case "e":
      case "ee":
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      case "eo":
        return mapValue(match3.ordinalNumber(dateString, {
          unit: "day"
        }), valueCallback);
      case "eee":
        return match3.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.day(dateString, { width: "short", context: "formatting" }) || match3.day(dateString, { width: "narrow", context: "formatting" });
      case "eeeee":
        return match3.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return match3.day(dateString, { width: "short", context: "formatting" }) || match3.day(dateString, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return match3.day(dateString, { width: "wide", context: "formatting" }) || match3.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.day(dateString, { width: "short", context: "formatting" }) || match3.day(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T"
  ];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/StandAloneLocalDayParser.mjs
class StandAloneLocalDayParser extends Parser {
  priority = 90;
  parse(dateString, token, match3, options) {
    const valueCallback = (value) => {
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return (value + options.weekStartsOn + 6 + 1) % 7 + wholeWeekDays;
    };
    switch (token) {
      case "c":
      case "cc":
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      case "co":
        return mapValue(match3.ordinalNumber(dateString, {
          unit: "day"
        }), valueCallback);
      case "ccc":
        return match3.day(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match3.day(dateString, { width: "short", context: "standalone" }) || match3.day(dateString, { width: "narrow", context: "standalone" });
      case "ccccc":
        return match3.day(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return match3.day(dateString, { width: "short", context: "standalone" }) || match3.day(dateString, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return match3.day(dateString, { width: "wide", context: "standalone" }) || match3.day(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match3.day(dateString, { width: "short", context: "standalone" }) || match3.day(dateString, { width: "narrow", context: "standalone" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T"
  ];
}

// ../../../../../../tmp/date-fns-jalali/setISODay.mjs
function setISODay(date, day) {
  const _date = toDate(date);
  const currentDay = getISODay(_date);
  const diff = day - currentDay;
  return addDays(_date, diff);
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/ISODayParser.mjs
class ISODayParser extends Parser {
  priority = 90;
  parse(dateString, token, match3) {
    const valueCallback = (value) => {
      if (value === 0) {
        return 7;
      }
      return value;
    };
    switch (token) {
      case "i":
      case "ii":
        return parseNDigits(token.length, dateString);
      case "io":
        return match3.ordinalNumber(dateString, { unit: "day" });
      case "iii":
        return mapValue(match3.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match3.day(dateString, {
          width: "narrow",
          context: "formatting"
        }), valueCallback);
      case "iiiii":
        return mapValue(match3.day(dateString, {
          width: "narrow",
          context: "formatting"
        }), valueCallback);
      case "iiiiii":
        return mapValue(match3.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match3.day(dateString, {
          width: "narrow",
          context: "formatting"
        }), valueCallback);
      case "iiii":
      default:
        return mapValue(match3.day(dateString, {
          width: "wide",
          context: "formatting"
        }) || match3.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match3.day(dateString, {
          width: "narrow",
          context: "formatting"
        }), valueCallback);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 7;
  }
  set(date, _flags, value) {
    date = setISODay(date, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T"
  ];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/AMPMParser.mjs
class AMPMParser extends Parser {
  priority = 80;
  parse(dateString, token, match3) {
    switch (token) {
      case "a":
      case "aa":
      case "aaa":
        return match3.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return match3.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/AMPMMidnightParser.mjs
class AMPMMidnightParser extends Parser {
  priority = 80;
  parse(dateString, token, match3) {
    switch (token) {
      case "b":
      case "bb":
      case "bbb":
        return match3.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return match3.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/DayPeriodParser.mjs
class DayPeriodParser extends Parser {
  priority = 80;
  parse(dateString, token, match3) {
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return match3.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return match3.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["a", "b", "t", "T"];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/Hour1to12Parser.mjs
class Hour1to12Parser extends Parser {
  priority = 70;
  parse(dateString, token, match3) {
    switch (token) {
      case "h":
        return parseNumericPattern(numericPatterns.hour12h, dateString);
      case "ho":
        return match3.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 12;
  }
  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else if (!isPM && value === 12) {
      date.setHours(0, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }
  incompatibleTokens = ["H", "K", "k", "t", "T"];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/Hour0to23Parser.mjs
class Hour0to23Parser extends Parser {
  priority = 70;
  parse(dateString, token, match3) {
    switch (token) {
      case "H":
        return parseNumericPattern(numericPatterns.hour23h, dateString);
      case "Ho":
        return match3.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 23;
  }
  set(date, _flags, value) {
    date.setHours(value, 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/Hour0To11Parser.mjs
class Hour0To11Parser extends Parser {
  priority = 70;
  parse(dateString, token, match3) {
    switch (token) {
      case "K":
        return parseNumericPattern(numericPatterns.hour11h, dateString);
      case "Ko":
        return match3.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }
  incompatibleTokens = ["h", "H", "k", "t", "T"];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/Hour1To24Parser.mjs
class Hour1To24Parser extends Parser {
  priority = 70;
  parse(dateString, token, match3) {
    switch (token) {
      case "k":
        return parseNumericPattern(numericPatterns.hour24h, dateString);
      case "ko":
        return match3.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 24;
  }
  set(date, _flags, value) {
    const hours = value <= 24 ? value % 24 : value;
    date.setHours(hours, 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/MinuteParser.mjs
class MinuteParser extends Parser {
  priority = 60;
  parse(dateString, token, match3) {
    switch (token) {
      case "m":
        return parseNumericPattern(numericPatterns.minute, dateString);
      case "mo":
        return match3.ordinalNumber(dateString, { unit: "minute" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 59;
  }
  set(date, _flags, value) {
    date.setMinutes(value, 0, 0);
    return date;
  }
  incompatibleTokens = ["t", "T"];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/SecondParser.mjs
class SecondParser extends Parser {
  priority = 50;
  parse(dateString, token, match3) {
    switch (token) {
      case "s":
        return parseNumericPattern(numericPatterns.second, dateString);
      case "so":
        return match3.ordinalNumber(dateString, { unit: "second" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 59;
  }
  set(date, _flags, value) {
    date.setSeconds(value, 0);
    return date;
  }
  incompatibleTokens = ["t", "T"];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/FractionOfSecondParser.mjs
class FractionOfSecondParser extends Parser {
  priority = 30;
  parse(dateString, token) {
    const valueCallback = (value) => Math.trunc(value * Math.pow(10, -token.length + 3));
    return mapValue(parseNDigits(token.length, dateString), valueCallback);
  }
  set(date, _flags, value) {
    date.setMilliseconds(value);
    return date;
  }
  incompatibleTokens = ["t", "T"];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/ISOTimezoneWithZParser.mjs
class ISOTimezoneWithZParser extends Parser {
  priority = 10;
  parse(dateString, token) {
    switch (token) {
      case "X":
        return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
      case "XX":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "XXXX":
        return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
      case "XXXXX":
        return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
      case "XXX":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }
  set(date, flags, value) {
    if (flags.timestampIsSet)
      return date;
    return constructFrom(date, date.getTime() - getTimezoneOffsetInMilliseconds(date) - value);
  }
  incompatibleTokens = ["t", "T", "x"];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/ISOTimezoneParser.mjs
class ISOTimezoneParser extends Parser {
  priority = 10;
  parse(dateString, token) {
    switch (token) {
      case "x":
        return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
      case "xx":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "xxxx":
        return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
      case "xxxxx":
        return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
      case "xxx":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }
  set(date, flags, value) {
    if (flags.timestampIsSet)
      return date;
    return constructFrom(date, date.getTime() - getTimezoneOffsetInMilliseconds(date) - value);
  }
  incompatibleTokens = ["t", "T", "X"];
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/TimestampSecondsParser.mjs
class TimestampSecondsParser extends Parser {
  priority = 40;
  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }
  set(date, _flags, value) {
    return [constructFrom(date, value * 1000), { timestampIsSet: true }];
  }
  incompatibleTokens = "*";
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers/TimestampMillisecondsParser.mjs
class TimestampMillisecondsParser extends Parser {
  priority = 20;
  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }
  set(date, _flags, value) {
    return [constructFrom(date, value), { timestampIsSet: true }];
  }
  incompatibleTokens = "*";
}

// ../../../../../../tmp/date-fns-jalali/parse/_lib/parsers.mjs
var parsers = {
  G: new EraParser,
  y: new YearParser,
  Y: new LocalWeekYearParser,
  R: new ISOWeekYearParser,
  u: new ExtendedYearParser,
  Q: new QuarterParser,
  q: new StandAloneQuarterParser,
  M: new MonthParser,
  L: new StandAloneMonthParser,
  w: new LocalWeekParser,
  I: new ISOWeekParser,
  d: new DateParser,
  D: new DayOfYearParser,
  E: new DayParser,
  e: new LocalDayParser,
  c: new StandAloneLocalDayParser,
  i: new ISODayParser,
  a: new AMPMParser,
  b: new AMPMMidnightParser,
  B: new DayPeriodParser,
  h: new Hour1to12Parser,
  H: new Hour0to23Parser,
  K: new Hour0To11Parser,
  k: new Hour1To24Parser,
  m: new MinuteParser,
  s: new SecondParser,
  S: new FractionOfSecondParser,
  X: new ISOTimezoneWithZParser,
  x: new ISOTimezoneParser,
  t: new TimestampSecondsParser,
  T: new TimestampMillisecondsParser
};

// ../../../../../../tmp/date-fns-jalali/parse.mjs
function parse(dateStr, formatStr, referenceDate, options) {
  const defaultOptions14 = getDefaultOptions2();
  const locale = options?.locale ?? defaultOptions14.locale ?? faIR;
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions14.firstWeekContainsDate ?? defaultOptions14.locale?.options?.firstWeekContainsDate ?? 1;
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions14.weekStartsOn ?? defaultOptions14.locale?.options?.weekStartsOn ?? 6;
  if (formatStr === "") {
    if (dateStr === "") {
      return toDate(referenceDate);
    } else {
      return constructFrom(referenceDate, NaN);
    }
  }
  const subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale
  };
  const setters = [new DateToSystemTimezoneSetter];
  const tokens = formatStr.match(longFormattingTokensRegExp2).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter in longFormatters) {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp2);
  const usedTokens = [];
  for (let token of tokens) {
    if (!options?.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, dateStr);
    }
    if (!options?.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, dateStr);
    }
    const firstCharacter = token[0];
    const parser = parsers[firstCharacter];
    if (parser) {
      const { incompatibleTokens } = parser;
      if (Array.isArray(incompatibleTokens)) {
        const incompatibleToken = usedTokens.find((usedToken) => incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
        if (incompatibleToken) {
          throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
        }
      } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
        throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
      }
      usedTokens.push({ token: firstCharacter, fullToken: token });
      const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
      if (!parseResult) {
        return constructFrom(referenceDate, NaN);
      }
      setters.push(parseResult.setter);
      dateStr = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp2)) {
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
      }
      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString2(token);
      }
      if (dateStr.indexOf(token) === 0) {
        dateStr = dateStr.slice(token.length);
      } else {
        return constructFrom(referenceDate, NaN);
      }
    }
  }
  if (dateStr.length > 0 && notWhitespaceRegExp.test(dateStr)) {
    return constructFrom(referenceDate, NaN);
  }
  const uniquePrioritySetters = setters.map((setter) => setter.priority).sort((a, b) => b - a).filter((priority, index, array) => array.indexOf(priority) === index).map((priority) => setters.filter((setter) => setter.priority === priority).sort((a, b) => b.subPriority - a.subPriority)).map((setterArray) => setterArray[0]);
  let date = toDate(referenceDate);
  if (isNaN(date.getTime())) {
    return constructFrom(referenceDate, NaN);
  }
  const flags = {};
  for (const setter of uniquePrioritySetters) {
    if (!setter.validate(date, subFnOptions)) {
      return constructFrom(referenceDate, NaN);
    }
    const result = setter.set(date, flags, subFnOptions);
    if (Array.isArray(result)) {
      date = result[0];
      Object.assign(flags, result[1]);
    } else {
      date = result;
    }
  }
  return constructFrom(referenceDate, date);
}
var cleanEscapedString2 = function(input) {
  return input.match(escapedStringRegExp2)[1].replace(doubleQuoteRegExp2, "'");
};
var formattingTokensRegExp2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp2 = /^'([^]*?)'?$/;
var doubleQuoteRegExp2 = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp2 = /[a-zA-Z]/;

// ../../../../../../tmp/date-fns-jalali/isMatch.mjs
function isMatch(dateStr, formatStr, options) {
  return isValid(parse(dateStr, formatStr, newDate(), options));
}

// ../../../../../../tmp/date-fns-jalali/fp/isMatch.mjs
var isMatch3 = convertToFP(isMatch, 2);
// ../../../../../../tmp/date-fns-jalali/fp/isMatchWithOptions.mjs
var isMatchWithOptions = convertToFP(isMatch, 3);
// ../../../../../../tmp/date-fns-jalali/isMonday.mjs
function isMonday(date) {
  return toDate(date).getDay() === 1;
}

// ../../../../../../tmp/date-fns-jalali/fp/isMonday.mjs
var isMonday3 = convertToFP(isMonday, 1);
// ../../../../../../tmp/date-fns-jalali/fp/isSameDay.mjs
var isSameDay4 = convertToFP(isSameDay, 2);
// ../../../../../../tmp/date-fns-jalali/startOfHour.mjs
function startOfHour(date) {
  const _date = toDate(date);
  _date.setMinutes(0, 0, 0);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/isSameHour.mjs
function isSameHour(dateLeft, dateRight) {
  const dateLeftStartOfHour = startOfHour(dateLeft);
  const dateRightStartOfHour = startOfHour(dateRight);
  return +dateLeftStartOfHour === +dateRightStartOfHour;
}

// ../../../../../../tmp/date-fns-jalali/fp/isSameHour.mjs
var isSameHour3 = convertToFP(isSameHour, 2);
// ../../../../../../tmp/date-fns-jalali/isSameWeek.mjs
function isSameWeek(dateLeft, dateRight, options) {
  const dateLeftStartOfWeek = startOfWeek(dateLeft, options);
  const dateRightStartOfWeek = startOfWeek(dateRight, options);
  return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}

// ../../../../../../tmp/date-fns-jalali/isSameISOWeek.mjs
function isSameISOWeek(dateLeft, dateRight) {
  return isSameWeek(dateLeft, dateRight, { weekStartsOn: 1 });
}

// ../../../../../../tmp/date-fns-jalali/fp/isSameISOWeek.mjs
var isSameISOWeek3 = convertToFP(isSameISOWeek, 2);
// ../../../../../../tmp/date-fns-jalali/isSameISOWeekYear.mjs
function isSameISOWeekYear(dateLeft, dateRight) {
  const dateLeftStartOfYear = startOfISOWeekYear(dateLeft);
  const dateRightStartOfYear = startOfISOWeekYear(dateRight);
  return +dateLeftStartOfYear === +dateRightStartOfYear;
}

// ../../../../../../tmp/date-fns-jalali/fp/isSameISOWeekYear.mjs
var isSameISOWeekYear3 = convertToFP(isSameISOWeekYear, 2);
// ../../../../../../tmp/date-fns-jalali/isSameMinute.mjs
function isSameMinute(dateLeft, dateRight) {
  const dateLeftStartOfMinute = startOfMinute(dateLeft);
  const dateRightStartOfMinute = startOfMinute(dateRight);
  return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}

// ../../../../../../tmp/date-fns-jalali/fp/isSameMinute.mjs
var isSameMinute3 = convertToFP(isSameMinute, 2);
// ../../../../../../tmp/date-fns-jalali/isSameMonth.mjs
function isSameMonth(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  return getFullYear(_dateLeft) === getFullYear(_dateRight) && getMonth(_dateLeft) === getMonth(_dateRight);
}

// ../../../../../../tmp/date-fns-jalali/fp/isSameMonth.mjs
var isSameMonth3 = convertToFP(isSameMonth, 2);
// ../../../../../../tmp/date-fns-jalali/isSameQuarter.mjs
function isSameQuarter(dateLeft, dateRight) {
  const dateLeftStartOfQuarter = startOfQuarter(dateLeft);
  const dateRightStartOfQuarter = startOfQuarter(dateRight);
  return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}

// ../../../../../../tmp/date-fns-jalali/fp/isSameQuarter.mjs
var isSameQuarter3 = convertToFP(isSameQuarter, 2);
// ../../../../../../tmp/date-fns-jalali/startOfSecond.mjs
function startOfSecond(date) {
  const _date = toDate(date);
  _date.setMilliseconds(0);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/isSameSecond.mjs
function isSameSecond(dateLeft, dateRight) {
  const dateLeftStartOfSecond = startOfSecond(dateLeft);
  const dateRightStartOfSecond = startOfSecond(dateRight);
  return +dateLeftStartOfSecond === +dateRightStartOfSecond;
}

// ../../../../../../tmp/date-fns-jalali/fp/isSameSecond.mjs
var isSameSecond3 = convertToFP(isSameSecond, 2);
// ../../../../../../tmp/date-fns-jalali/fp/isSameWeek.mjs
var isSameWeek4 = convertToFP(isSameWeek, 2);
// ../../../../../../tmp/date-fns-jalali/fp/isSameWeekWithOptions.mjs
var isSameWeekWithOptions = convertToFP(isSameWeek, 3);
// ../../../../../../tmp/date-fns-jalali/isSameYear.mjs
function isSameYear(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  return getFullYear(_dateLeft) === getFullYear(_dateRight);
}

// ../../../../../../tmp/date-fns-jalali/fp/isSameYear.mjs
var isSameYear3 = convertToFP(isSameYear, 2);
// ../../../../../../tmp/date-fns-jalali/fp/isSaturday.mjs
var isSaturday4 = convertToFP(isSaturday, 1);
// ../../../../../../tmp/date-fns-jalali/fp/isSunday.mjs
var isSunday4 = convertToFP(isSunday, 1);
// ../../../../../../tmp/date-fns-jalali/isThursday.mjs
function isThursday(date) {
  return toDate(date).getDay() === 4;
}

// ../../../../../../tmp/date-fns-jalali/fp/isThursday.mjs
var isThursday3 = convertToFP(isThursday, 1);
// ../../../../../../tmp/date-fns-jalali/isTuesday.mjs
function isTuesday(date) {
  return toDate(date).getDay() === 2;
}

// ../../../../../../tmp/date-fns-jalali/fp/isTuesday.mjs
var isTuesday3 = convertToFP(isTuesday, 1);
// ../../../../../../tmp/date-fns-jalali/fp/isValid.mjs
var isValid9 = convertToFP(isValid, 1);
// ../../../../../../tmp/date-fns-jalali/isWednesday.mjs
function isWednesday(date) {
  return toDate(date).getDay() === 3;
}

// ../../../../../../tmp/date-fns-jalali/fp/isWednesday.mjs
var isWednesday3 = convertToFP(isWednesday, 1);
// ../../../../../../tmp/date-fns-jalali/fp/isWeekend.mjs
var isWeekend6 = convertToFP(isWeekend, 1);
// ../../../../../../tmp/date-fns-jalali/isWithinInterval.mjs
function isWithinInterval(date, interval5) {
  const time = +toDate(date);
  const [startTime, endTime] = [
    +toDate(interval5.start),
    +toDate(interval5.end)
  ].sort((a, b) => a - b);
  return time >= startTime && time <= endTime;
}

// ../../../../../../tmp/date-fns-jalali/fp/isWithinInterval.mjs
var isWithinInterval3 = convertToFP(isWithinInterval, 2);
// ../../../../../../tmp/date-fns-jalali/lastDayOfDecade.mjs
function lastDayOfDecade(date) {
  const _date = toDate(date);
  const year = getFullYear(_date);
  const decade = 9 + Math.floor(year / 10) * 10;
  setFullYear(_date, decade + 1, 0, 0);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/lastDayOfDecade.mjs
var lastDayOfDecade3 = convertToFP(lastDayOfDecade, 1);
// ../../../../../../tmp/date-fns-jalali/lastDayOfWeek.mjs
function lastDayOfWeek(date, options) {
  const defaultOptions15 = getDefaultOptions();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions15.weekStartsOn ?? defaultOptions15.locale?.options?.weekStartsOn ?? 6;
  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  _date.setHours(0, 0, 0, 0);
  setDate(_date, getDate(_date) + diff);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/lastDayOfISOWeek.mjs
function lastDayOfISOWeek(date) {
  return lastDayOfWeek(date, { weekStartsOn: 1 });
}

// ../../../../../../tmp/date-fns-jalali/fp/lastDayOfISOWeek.mjs
var lastDayOfISOWeek3 = convertToFP(lastDayOfISOWeek, 1);
// ../../../../../../tmp/date-fns-jalali/lastDayOfISOWeekYear.mjs
function lastDayOfISOWeekYear(date) {
  const year = getISOWeekYear(date);
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(year + 1, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  const _date = startOfISOWeek(fourthOfJanuary);
  _date.setDate(_date.getDate() - 1);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/lastDayOfISOWeekYear.mjs
var lastDayOfISOWeekYear3 = convertToFP(lastDayOfISOWeekYear, 1);
// ../../../../../../tmp/date-fns-jalali/fp/lastDayOfMonth.mjs
var lastDayOfMonth4 = convertToFP(lastDayOfMonth, 1);
// ../../../../../../tmp/date-fns-jalali/lastDayOfQuarter.mjs
function lastDayOfQuarter(date) {
  const _date = toDate(date);
  const currentMonth = getMonth(_date);
  const month = currentMonth - currentMonth % 3 + 3;
  setMonth(_date, month, 0);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/lastDayOfQuarter.mjs
var lastDayOfQuarter3 = convertToFP(lastDayOfQuarter, 1);
// ../../../../../../tmp/date-fns-jalali/fp/lastDayOfWeek.mjs
var lastDayOfWeek4 = convertToFP(lastDayOfWeek, 1);
// ../../../../../../tmp/date-fns-jalali/fp/lastDayOfWeekWithOptions.mjs
var lastDayOfWeekWithOptions = convertToFP(lastDayOfWeek, 2);
// ../../../../../../tmp/date-fns-jalali/lastDayOfYear.mjs
function lastDayOfYear(date) {
  const _date = toDate(date);
  const year = getFullYear(_date);
  setFullYear(_date, year + 1, 0, 0);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/lastDayOfYear.mjs
var lastDayOfYear3 = convertToFP(lastDayOfYear, 1);
// ../../../../../../tmp/date-fns-jalali/lightFormat.mjs
function lightFormat(date, formatStr) {
  const _date = toDate(date);
  if (!isValid(_date)) {
    throw new RangeError("Invalid time value");
  }
  const tokens = formatStr.match(formattingTokensRegExp3);
  if (!tokens)
    return "";
  const result = tokens.map((substring) => {
    if (substring === "''") {
      return "'";
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString3(substring);
    }
    const formatter = lightFormatters[firstCharacter];
    if (formatter) {
      return formatter(_date, substring);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp3)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
var cleanEscapedString3 = function(input) {
  const matches = input.match(escapedStringRegExp3);
  if (!matches) {
    return input;
  }
  return matches[1].replace(doubleQuoteRegExp3, "'");
};
var formattingTokensRegExp3 = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp3 = /^'([^]*?)'?$/;
var doubleQuoteRegExp3 = /''/g;
var unescapedLatinCharacterRegExp3 = /[a-zA-Z]/;

// ../../../../../../tmp/date-fns-jalali/fp/lightFormat.mjs
var lightFormat3 = convertToFP(lightFormat, 2);
// ../../../../../../tmp/date-fns-jalali/fp/max.mjs
var max4 = convertToFP(max, 1);
// ../../../../../../tmp/date-fns-jalali/milliseconds.mjs
function milliseconds({
  years,
  months: months2,
  weeks,
  days: days2,
  hours,
  minutes,
  seconds
}) {
  let totalDays = 0;
  if (years)
    totalDays += years * daysInYear;
  if (months2)
    totalDays += months2 * (daysInYear / 12);
  if (weeks)
    totalDays += weeks * 7;
  if (days2)
    totalDays += days2;
  let totalSeconds = totalDays * 24 * 60 * 60;
  if (hours)
    totalSeconds += hours * 60 * 60;
  if (minutes)
    totalSeconds += minutes * 60;
  if (seconds)
    totalSeconds += seconds;
  return Math.trunc(totalSeconds * 1000);
}

// ../../../../../../tmp/date-fns-jalali/fp/milliseconds.mjs
var milliseconds3 = convertToFP(milliseconds, 1);
// ../../../../../../tmp/date-fns-jalali/millisecondsToHours.mjs
function millisecondsToHours(milliseconds4) {
  const hours = milliseconds4 / millisecondsInHour;
  return Math.trunc(hours);
}

// ../../../../../../tmp/date-fns-jalali/fp/millisecondsToHours.mjs
var millisecondsToHours3 = convertToFP(millisecondsToHours, 1);
// ../../../../../../tmp/date-fns-jalali/millisecondsToMinutes.mjs
function millisecondsToMinutes(milliseconds4) {
  const minutes = milliseconds4 / millisecondsInMinute;
  return Math.trunc(minutes);
}

// ../../../../../../tmp/date-fns-jalali/fp/millisecondsToMinutes.mjs
var millisecondsToMinutes3 = convertToFP(millisecondsToMinutes, 1);
// ../../../../../../tmp/date-fns-jalali/millisecondsToSeconds.mjs
function millisecondsToSeconds(milliseconds4) {
  const seconds = milliseconds4 / millisecondsInSecond;
  return Math.trunc(seconds);
}

// ../../../../../../tmp/date-fns-jalali/fp/millisecondsToSeconds.mjs
var millisecondsToSeconds3 = convertToFP(millisecondsToSeconds, 1);
// ../../../../../../tmp/date-fns-jalali/fp/min.mjs
var min4 = convertToFP(min, 1);
// ../../../../../../tmp/date-fns-jalali/minutesToHours.mjs
function minutesToHours(minutes) {
  const hours = minutes / minutesInHour;
  return Math.trunc(hours);
}

// ../../../../../../tmp/date-fns-jalali/fp/minutesToHours.mjs
var minutesToHours3 = convertToFP(minutesToHours, 1);
// ../../../../../../tmp/date-fns-jalali/minutesToMilliseconds.mjs
function minutesToMilliseconds(minutes) {
  return Math.trunc(minutes * millisecondsInMinute);
}

// ../../../../../../tmp/date-fns-jalali/fp/minutesToMilliseconds.mjs
var minutesToMilliseconds3 = convertToFP(minutesToMilliseconds, 1);
// ../../../../../../tmp/date-fns-jalali/minutesToSeconds.mjs
function minutesToSeconds(minutes) {
  return Math.trunc(minutes * secondsInMinute);
}

// ../../../../../../tmp/date-fns-jalali/fp/minutesToSeconds.mjs
var minutesToSeconds3 = convertToFP(minutesToSeconds, 1);
// ../../../../../../tmp/date-fns-jalali/monthsToQuarters.mjs
function monthsToQuarters(months2) {
  const quarters = months2 / monthsInQuarter;
  return Math.trunc(quarters);
}

// ../../../../../../tmp/date-fns-jalali/fp/monthsToQuarters.mjs
var monthsToQuarters3 = convertToFP(monthsToQuarters, 1);
// ../../../../../../tmp/date-fns-jalali/monthsToYears.mjs
function monthsToYears(months2) {
  const years = months2 / monthsInYear;
  return Math.trunc(years);
}

// ../../../../../../tmp/date-fns-jalali/fp/monthsToYears.mjs
var monthsToYears3 = convertToFP(monthsToYears, 1);
// ../../../../../../tmp/date-fns-jalali/nextDay.mjs
function nextDay(date, day) {
  let delta = day - getDay(date);
  if (delta <= 0)
    delta += 7;
  return addDays(date, delta);
}

// ../../../../../../tmp/date-fns-jalali/fp/nextDay.mjs
var nextDay3 = convertToFP(nextDay, 2);
// ../../../../../../tmp/date-fns-jalali/nextFriday.mjs
function nextFriday(date) {
  return nextDay(date, 5);
}

// ../../../../../../tmp/date-fns-jalali/fp/nextFriday.mjs
var nextFriday3 = convertToFP(nextFriday, 1);
// ../../../../../../tmp/date-fns-jalali/nextMonday.mjs
function nextMonday(date) {
  return nextDay(date, 1);
}

// ../../../../../../tmp/date-fns-jalali/fp/nextMonday.mjs
var nextMonday3 = convertToFP(nextMonday, 1);
// ../../../../../../tmp/date-fns-jalali/nextSaturday.mjs
function nextSaturday(date) {
  return nextDay(date, 6);
}

// ../../../../../../tmp/date-fns-jalali/fp/nextSaturday.mjs
var nextSaturday3 = convertToFP(nextSaturday, 1);
// ../../../../../../tmp/date-fns-jalali/nextSunday.mjs
function nextSunday(date) {
  return nextDay(date, 0);
}

// ../../../../../../tmp/date-fns-jalali/fp/nextSunday.mjs
var nextSunday3 = convertToFP(nextSunday, 1);
// ../../../../../../tmp/date-fns-jalali/nextThursday.mjs
function nextThursday(date) {
  return nextDay(date, 4);
}

// ../../../../../../tmp/date-fns-jalali/fp/nextThursday.mjs
var nextThursday3 = convertToFP(nextThursday, 1);
// ../../../../../../tmp/date-fns-jalali/nextTuesday.mjs
function nextTuesday(date) {
  return nextDay(date, 2);
}

// ../../../../../../tmp/date-fns-jalali/fp/nextTuesday.mjs
var nextTuesday3 = convertToFP(nextTuesday, 1);
// ../../../../../../tmp/date-fns-jalali/nextWednesday.mjs
function nextWednesday(date) {
  return nextDay(date, 3);
}

// ../../../../../../tmp/date-fns-jalali/fp/nextWednesday.mjs
var nextWednesday3 = convertToFP(nextWednesday, 1);
// ../../../../../../tmp/date-fns-jalali/fp/parse.mjs
var parse4 = convertToFP(parse, 3);
// ../../../../../../tmp/date-fns-jalali/parseISO.mjs
function parseISO(argument, options) {
  const additionalDigits = options?.additionalDigits ?? 2;
  const dateStrings = splitDateString(argument);
  let date;
  if (dateStrings.date) {
    const parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }
  const timestamp = date.getTime();
  let time = 0;
  let offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    const dirtyDate = new Date(timestamp + time);
    const result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset);
}
var splitDateString = function(dateString) {
  const dateStrings = {};
  const array = dateString.split(patterns.dateTimeDelimiter);
  let timeString;
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    const token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], "");
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
};
var parseYear = function(dateString, additionalDigits) {
  const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
  const captures = dateString.match(regex);
  if (!captures)
    return { year: NaN, restDateString: "" };
  const year = captures[1] ? parseInt(captures[1]) : null;
  const century = captures[2] ? parseInt(captures[2]) : null;
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
};
var parseDate = function(dateString, year) {
  if (year === null)
    return new Date(NaN);
  const captures = dateString.match(dateRegex);
  if (!captures)
    return new Date(NaN);
  const isWeekDate = !!captures[4];
  const dayOfYear = parseDateUnit(captures[1]);
  const month = parseDateUnit(captures[2]) - 1;
  const day = parseDateUnit(captures[3]);
  const week = parseDateUnit(captures[4]);
  const dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    const date = new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
};
var parseDateUnit = function(value) {
  return value ? parseInt(value) : 1;
};
var parseTime = function(timeString) {
  const captures = timeString.match(timeRegex);
  if (!captures)
    return NaN;
  const hours = parseTimeUnit(captures[1]);
  const minutes = parseTimeUnit(captures[2]);
  const seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
};
var parseTimeUnit = function(value) {
  return value && parseFloat(value.replace(",", ".")) || 0;
};
var parseTimezone = function(timezoneString) {
  if (timezoneString === "Z")
    return 0;
  const captures = timezoneString.match(timezoneRegex);
  if (!captures)
    return 0;
  const sign = captures[1] === "+" ? -1 : 1;
  const hours = parseInt(captures[2]);
  const minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
};
var dayOfISOWeekYear = function(isoWeekYear, week, day) {
  const date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  const fourthOfJanuaryDay = date.getUTCDay() || 7;
  const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
};
var isLeapYearIndex2 = function(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
};
var validateDate = function(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex2(year) ? 29 : 28));
};
var validateDayOfYearDate = function(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex2(year) ? 366 : 365);
};
var validateWeekDate = function(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
};
var validateTime = function(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
};
var validateTimezone = function(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
};
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// ../../../../../../tmp/date-fns-jalali/fp/parseISO.mjs
var parseISO3 = convertToFP(parseISO, 1);
// ../../../../../../tmp/date-fns-jalali/fp/parseISOWithOptions.mjs
var parseISOWithOptions = convertToFP(parseISO, 2);
// ../../../../../../tmp/date-fns-jalali/parseJSON.mjs
function parseJSON(dateStr) {
  const parts = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
  if (parts) {
    return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
  }
  return new Date(NaN);
}

// ../../../../../../tmp/date-fns-jalali/fp/parseJSON.mjs
var parseJSON3 = convertToFP(parseJSON, 1);
// ../../../../../../tmp/date-fns-jalali/fp/parseWithOptions.mjs
var parseWithOptions = convertToFP(parse, 4);
// ../../../../../../tmp/date-fns-jalali/subDays.mjs
function subDays(date, amount) {
  return addDays(date, -amount);
}

// ../../../../../../tmp/date-fns-jalali/previousDay.mjs
function previousDay(date, day) {
  let delta = getDay(date) - day;
  if (delta <= 0)
    delta += 7;
  return subDays(date, delta);
}

// ../../../../../../tmp/date-fns-jalali/fp/previousDay.mjs
var previousDay3 = convertToFP(previousDay, 2);
// ../../../../../../tmp/date-fns-jalali/previousFriday.mjs
function previousFriday(date) {
  return previousDay(date, 5);
}

// ../../../../../../tmp/date-fns-jalali/fp/previousFriday.mjs
var previousFriday3 = convertToFP(previousFriday, 1);
// ../../../../../../tmp/date-fns-jalali/previousMonday.mjs
function previousMonday(date) {
  return previousDay(date, 1);
}

// ../../../../../../tmp/date-fns-jalali/fp/previousMonday.mjs
var previousMonday3 = convertToFP(previousMonday, 1);
// ../../../../../../tmp/date-fns-jalali/previousSaturday.mjs
function previousSaturday(date) {
  return previousDay(date, 6);
}

// ../../../../../../tmp/date-fns-jalali/fp/previousSaturday.mjs
var previousSaturday3 = convertToFP(previousSaturday, 1);
// ../../../../../../tmp/date-fns-jalali/previousSunday.mjs
function previousSunday(date) {
  return previousDay(date, 0);
}

// ../../../../../../tmp/date-fns-jalali/fp/previousSunday.mjs
var previousSunday3 = convertToFP(previousSunday, 1);
// ../../../../../../tmp/date-fns-jalali/previousThursday.mjs
function previousThursday(date) {
  return previousDay(date, 4);
}

// ../../../../../../tmp/date-fns-jalali/fp/previousThursday.mjs
var previousThursday3 = convertToFP(previousThursday, 1);
// ../../../../../../tmp/date-fns-jalali/previousTuesday.mjs
function previousTuesday(date) {
  return previousDay(date, 2);
}

// ../../../../../../tmp/date-fns-jalali/fp/previousTuesday.mjs
var previousTuesday3 = convertToFP(previousTuesday, 1);
// ../../../../../../tmp/date-fns-jalali/previousWednesday.mjs
function previousWednesday(date) {
  return previousDay(date, 3);
}

// ../../../../../../tmp/date-fns-jalali/fp/previousWednesday.mjs
var previousWednesday3 = convertToFP(previousWednesday, 1);
// ../../../../../../tmp/date-fns-jalali/quartersToMonths.mjs
function quartersToMonths(quarters) {
  return Math.trunc(quarters * monthsInQuarter);
}

// ../../../../../../tmp/date-fns-jalali/fp/quartersToMonths.mjs
var quartersToMonths3 = convertToFP(quartersToMonths, 1);
// ../../../../../../tmp/date-fns-jalali/quartersToYears.mjs
function quartersToYears(quarters) {
  const years = quarters / quartersInYear;
  return Math.trunc(years);
}

// ../../../../../../tmp/date-fns-jalali/fp/quartersToYears.mjs
var quartersToYears3 = convertToFP(quartersToYears, 1);
// ../../../../../../tmp/date-fns-jalali/roundToNearestHours.mjs
function roundToNearestHours(date, options) {
  const nearestTo = options?.nearestTo ?? 1;
  if (nearestTo < 1 || nearestTo > 12)
    return constructFrom(date, NaN);
  const _date = toDate(date);
  const fractionalMinutes = _date.getMinutes() / 60;
  const fractionalSeconds = _date.getSeconds() / 60 / 60;
  const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60 / 60;
  const hours = _date.getHours() + fractionalMinutes + fractionalSeconds + fractionalMilliseconds;
  const method = options?.roundingMethod ?? "round";
  const roundingMethod = getRoundingMethod(method);
  const roundedHours = roundingMethod(hours / nearestTo) * nearestTo;
  const result = constructFrom(date, _date);
  result.setHours(roundedHours, 0, 0, 0);
  return result;
}

// ../../../../../../tmp/date-fns-jalali/fp/roundToNearestHours.mjs
var roundToNearestHours3 = convertToFP(roundToNearestHours, 1);
// ../../../../../../tmp/date-fns-jalali/fp/roundToNearestHoursWithOptions.mjs
var roundToNearestHoursWithOptions = convertToFP(roundToNearestHours, 2);
// ../../../../../../tmp/date-fns-jalali/roundToNearestMinutes.mjs
function roundToNearestMinutes(date, options) {
  const nearestTo = options?.nearestTo ?? 1;
  if (nearestTo < 1 || nearestTo > 30)
    return constructFrom(date, NaN);
  const _date = toDate(date);
  const fractionalSeconds = _date.getSeconds() / 60;
  const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60;
  const minutes = _date.getMinutes() + fractionalSeconds + fractionalMilliseconds;
  const method = options?.roundingMethod ?? "round";
  const roundingMethod = getRoundingMethod(method);
  const roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
  const result = constructFrom(date, _date);
  result.setMinutes(roundedMinutes, 0, 0);
  return result;
}

// ../../../../../../tmp/date-fns-jalali/fp/roundToNearestMinutes.mjs
var roundToNearestMinutes3 = convertToFP(roundToNearestMinutes, 1);
// ../../../../../../tmp/date-fns-jalali/fp/roundToNearestMinutesWithOptions.mjs
var roundToNearestMinutesWithOptions = convertToFP(roundToNearestMinutes, 2);
// ../../../../../../tmp/date-fns-jalali/secondsToHours.mjs
function secondsToHours(seconds) {
  const hours = seconds / secondsInHour;
  return Math.trunc(hours);
}

// ../../../../../../tmp/date-fns-jalali/fp/secondsToHours.mjs
var secondsToHours3 = convertToFP(secondsToHours, 1);
// ../../../../../../tmp/date-fns-jalali/secondsToMilliseconds.mjs
function secondsToMilliseconds(seconds) {
  return seconds * millisecondsInSecond;
}

// ../../../../../../tmp/date-fns-jalali/fp/secondsToMilliseconds.mjs
var secondsToMilliseconds3 = convertToFP(secondsToMilliseconds, 1);
// ../../../../../../tmp/date-fns-jalali/secondsToMinutes.mjs
function secondsToMinutes(seconds) {
  const minutes = seconds / secondsInMinute;
  return Math.trunc(minutes);
}

// ../../../../../../tmp/date-fns-jalali/fp/secondsToMinutes.mjs
var secondsToMinutes3 = convertToFP(secondsToMinutes, 1);
// ../../../../../../tmp/date-fns-jalali/setMonth.mjs
function setMonth15(date, month) {
  const _date = toDate(date);
  const year = getFullYear(_date);
  const day = getDate(_date);
  const dateWithDesiredMonth = constructFrom(date, 0);
  setFullYear(dateWithDesiredMonth, year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  const daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  setMonth(_date, month, Math.min(day, daysInMonth));
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/set.mjs
function set(date, values) {
  let _date = toDate(date);
  if (isNaN(+_date)) {
    return constructFrom(date, NaN);
  }
  if (values.year != null) {
    setFullYear(_date, values.year);
  }
  if (values.month != null) {
    _date = setMonth15(_date, values.month);
  }
  if (values.date != null) {
    setDate(_date, values.date);
  }
  if (values.hours != null) {
    _date.setHours(values.hours);
  }
  if (values.minutes != null) {
    _date.setMinutes(values.minutes);
  }
  if (values.seconds != null) {
    _date.setSeconds(values.seconds);
  }
  if (values.milliseconds != null) {
    _date.setMilliseconds(values.milliseconds);
  }
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/set.mjs
var set3 = convertToFP(set, 2);
// ../../../../../../tmp/date-fns-jalali/setDate.mjs
function setDate16(date, dayOfMonth) {
  const _date = toDate(date);
  setDate(_date, dayOfMonth);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/setDate.mjs
var setDate18 = convertToFP(setDate16, 2);
// ../../../../../../tmp/date-fns-jalali/fp/setDay.mjs
var setDay6 = convertToFP(setDay, 2);
// ../../../../../../tmp/date-fns-jalali/setDayOfYear.mjs
function setDayOfYear(date, dayOfYear) {
  const _date = toDate(date);
  setMonth(_date, 0);
  setDate(_date, dayOfYear);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/setDayOfYear.mjs
var setDayOfYear3 = convertToFP(setDayOfYear, 2);
// ../../../../../../tmp/date-fns-jalali/fp/setDayWithOptions.mjs
var setDayWithOptions = convertToFP(setDay, 3);
// ../../../../../../tmp/date-fns-jalali/setHours.mjs
function setHours(date, hours) {
  const _date = toDate(date);
  _date.setHours(hours);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/setHours.mjs
var setHours3 = convertToFP(setHours, 2);
// ../../../../../../tmp/date-fns-jalali/fp/setISODay.mjs
var setISODay4 = convertToFP(setISODay, 2);
// ../../../../../../tmp/date-fns-jalali/fp/setISOWeek.mjs
var setISOWeek4 = convertToFP(setISOWeek, 2);
// ../../../../../../tmp/date-fns-jalali/fp/setISOWeekYear.mjs
var setISOWeekYear4 = convertToFP(setISOWeekYear, 2);
// ../../../../../../tmp/date-fns-jalali/setMilliseconds.mjs
function setMilliseconds(date, milliseconds4) {
  const _date = toDate(date);
  _date.setMilliseconds(milliseconds4);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/setMilliseconds.mjs
var setMilliseconds3 = convertToFP(setMilliseconds, 2);
// ../../../../../../tmp/date-fns-jalali/setMinutes.mjs
function setMinutes(date, minutes) {
  const _date = toDate(date);
  _date.setMinutes(minutes);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/setMinutes.mjs
var setMinutes3 = convertToFP(setMinutes, 2);
// ../../../../../../tmp/date-fns-jalali/fp/setMonth.mjs
var setMonth19 = convertToFP(setMonth15, 2);
// ../../../../../../tmp/date-fns-jalali/setQuarter.mjs
function setQuarter(date, quarter) {
  const _date = toDate(date);
  const oldQuarter = Math.trunc(getMonth(_date) / 3) + 1;
  const diff = quarter - oldQuarter;
  return setMonth15(_date, getMonth(_date) + diff * 3);
}

// ../../../../../../tmp/date-fns-jalali/fp/setQuarter.mjs
var setQuarter3 = convertToFP(setQuarter, 2);
// ../../../../../../tmp/date-fns-jalali/setSeconds.mjs
function setSeconds(date, seconds) {
  const _date = toDate(date);
  _date.setSeconds(seconds);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/setSeconds.mjs
var setSeconds3 = convertToFP(setSeconds, 2);
// ../../../../../../tmp/date-fns-jalali/fp/setWeek.mjs
var setWeek4 = convertToFP(setWeek, 2);
// ../../../../../../tmp/date-fns-jalali/fp/setWeekWithOptions.mjs
var setWeekWithOptions = convertToFP(setWeek, 3);
// ../../../../../../tmp/date-fns-jalali/setWeekYear.mjs
function setWeekYear(date, weekYear, options) {
  const defaultOptions16 = getDefaultOptions();
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions16.firstWeekContainsDate ?? defaultOptions16.locale?.options?.firstWeekContainsDate ?? 1;
  let _date = toDate(date);
  const diff = differenceInCalendarDays(_date, startOfWeekYear(_date, options));
  const firstWeek = constructFrom(date, 0);
  setFullYear(firstWeek, weekYear, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  _date = startOfWeekYear(firstWeek, options);
  setDate(_date, getDate(_date) + diff);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/setWeekYear.mjs
var setWeekYear3 = convertToFP(setWeekYear, 2);
// ../../../../../../tmp/date-fns-jalali/fp/setWeekYearWithOptions.mjs
var setWeekYearWithOptions = convertToFP(setWeekYear, 3);
// ../../../../../../tmp/date-fns-jalali/setYear.mjs
function setYear(date, year) {
  const _date = toDate(date);
  if (isNaN(+_date)) {
    return constructFrom(date, NaN);
  }
  setFullYear(_date, year);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/setYear.mjs
var setYear3 = convertToFP(setYear, 2);
// ../../../../../../tmp/date-fns-jalali/fp/startOfDay.mjs
var startOfDay5 = convertToFP(startOfDay, 1);
// ../../../../../../tmp/date-fns-jalali/startOfDecade.mjs
function startOfDecade(date) {
  const _date = toDate(date);
  const year = getFullYear(_date);
  const decade = Math.floor(year / 10) * 10;
  setFullYear(_date, decade, 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// ../../../../../../tmp/date-fns-jalali/fp/startOfDecade.mjs
var startOfDecade3 = convertToFP(startOfDecade, 1);
// ../../../../../../tmp/date-fns-jalali/fp/startOfHour.mjs
var startOfHour4 = convertToFP(startOfHour, 1);
// ../../../../../../tmp/date-fns-jalali/fp/startOfISOWeek.mjs
var startOfISOWeek11 = convertToFP(startOfISOWeek, 1);
// ../../../../../../tmp/date-fns-jalali/fp/startOfISOWeekYear.mjs
var startOfISOWeekYear7 = convertToFP(startOfISOWeekYear, 1);
// ../../../../../../tmp/date-fns-jalali/fp/startOfMinute.mjs
var startOfMinute5 = convertToFP(startOfMinute, 1);
// ../../../../../../tmp/date-fns-jalali/fp/startOfMonth.mjs
var startOfMonth6 = convertToFP(startOfMonth, 1);
// ../../../../../../tmp/date-fns-jalali/fp/startOfQuarter.mjs
var startOfQuarter5 = convertToFP(startOfQuarter, 1);
// ../../../../../../tmp/date-fns-jalali/fp/startOfSecond.mjs
var startOfSecond4 = convertToFP(startOfSecond, 1);
// ../../../../../../tmp/date-fns-jalali/fp/startOfWeek.mjs
var startOfWeek12 = convertToFP(startOfWeek, 1);
// ../../../../../../tmp/date-fns-jalali/fp/startOfWeekWithOptions.mjs
var startOfWeekWithOptions = convertToFP(startOfWeek, 2);
// ../../../../../../tmp/date-fns-jalali/fp/startOfWeekYear.mjs
var startOfWeekYear5 = convertToFP(startOfWeekYear, 1);
// ../../../../../../tmp/date-fns-jalali/fp/startOfWeekYearWithOptions.mjs
var startOfWeekYearWithOptions = convertToFP(startOfWeekYear, 2);
// ../../../../../../tmp/date-fns-jalali/fp/startOfYear.mjs
var startOfYear5 = convertToFP(startOfYear, 1);
// ../../../../../../tmp/date-fns-jalali/subMonths.mjs
function subMonths(date, amount) {
  return addMonths(date, -amount);
}

// ../../../../../../tmp/date-fns-jalali/sub.mjs
function sub(date, duration) {
  const {
    years = 0,
    months: months2 = 0,
    weeks = 0,
    days: days2 = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  } = duration;
  const dateWithoutMonths = subMonths(date, months2 + years * 12);
  const dateWithoutDays = subDays(dateWithoutMonths, days2 + weeks * 7);
  const minutestoSub = minutes + hours * 60;
  const secondstoSub = seconds + minutestoSub * 60;
  const mstoSub = secondstoSub * 1000;
  const finalDate = constructFrom(date, dateWithoutDays.getTime() - mstoSub);
  return finalDate;
}

// ../../../../../../tmp/date-fns-jalali/fp/sub.mjs
var sub3 = convertToFP(sub, 2);
// ../../../../../../tmp/date-fns-jalali/subBusinessDays.mjs
function subBusinessDays(date, amount) {
  return addBusinessDays(date, -amount);
}

// ../../../../../../tmp/date-fns-jalali/fp/subBusinessDays.mjs
var subBusinessDays3 = convertToFP(subBusinessDays, 2);
// ../../../../../../tmp/date-fns-jalali/fp/subDays.mjs
var subDays5 = convertToFP(subDays, 2);
// ../../../../../../tmp/date-fns-jalali/subHours.mjs
function subHours(date, amount) {
  return addHours(date, -amount);
}

// ../../../../../../tmp/date-fns-jalali/fp/subHours.mjs
var subHours3 = convertToFP(subHours, 2);
// ../../../../../../tmp/date-fns-jalali/fp/subISOWeekYears.mjs
var subISOWeekYears4 = convertToFP(subISOWeekYears, 2);
// ../../../../../../tmp/date-fns-jalali/subMilliseconds.mjs
function subMilliseconds(date, amount) {
  return addMilliseconds(date, -amount);
}

// ../../../../../../tmp/date-fns-jalali/fp/subMilliseconds.mjs
var subMilliseconds3 = convertToFP(subMilliseconds, 2);
// ../../../../../../tmp/date-fns-jalali/subMinutes.mjs
function subMinutes(date, amount) {
  return addMinutes(date, -amount);
}

// ../../../../../../tmp/date-fns-jalali/fp/subMinutes.mjs
var subMinutes3 = convertToFP(subMinutes, 2);
// ../../../../../../tmp/date-fns-jalali/fp/subMonths.mjs
var subMonths4 = convertToFP(subMonths, 2);
// ../../../../../../tmp/date-fns-jalali/subQuarters.mjs
function subQuarters(date, amount) {
  return addQuarters(date, -amount);
}

// ../../../../../../tmp/date-fns-jalali/fp/subQuarters.mjs
var subQuarters3 = convertToFP(subQuarters, 2);
// ../../../../../../tmp/date-fns-jalali/subSeconds.mjs
function subSeconds(date, amount) {
  return addSeconds(date, -amount);
}

// ../../../../../../tmp/date-fns-jalali/fp/subSeconds.mjs
var subSeconds3 = convertToFP(subSeconds, 2);
// ../../../../../../tmp/date-fns-jalali/subWeeks.mjs
function subWeeks(date, amount) {
  return addWeeks(date, -amount);
}

// ../../../../../../tmp/date-fns-jalali/fp/subWeeks.mjs
var subWeeks3 = convertToFP(subWeeks, 2);
// ../../../../../../tmp/date-fns-jalali/subYears.mjs
function subYears(date, amount) {
  return addYears(date, -amount);
}

// ../../../../../../tmp/date-fns-jalali/fp/subYears.mjs
var subYears3 = convertToFP(subYears, 2);
// ../../../../../../tmp/date-fns-jalali/fp/toDate.mjs
var toDate127 = convertToFP(toDate, 1);
// ../../../../../../tmp/date-fns-jalali/fp/transpose.mjs
var transpose4 = convertToFP(transpose, 2);
// ../../../../../../tmp/date-fns-jalali/weeksToDays.mjs
function weeksToDays(weeks) {
  return Math.trunc(weeks * daysInWeek);
}

// ../../../../../../tmp/date-fns-jalali/fp/weeksToDays.mjs
var weeksToDays3 = convertToFP(weeksToDays, 1);
// ../../../../../../tmp/date-fns-jalali/yearsToDays.mjs
function yearsToDays(years) {
  return Math.trunc(years * daysInYear);
}

// ../../../../../../tmp/date-fns-jalali/fp/yearsToDays.mjs
var yearsToDays3 = convertToFP(yearsToDays, 1);
// ../../../../../../tmp/date-fns-jalali/yearsToMonths.mjs
function yearsToMonths(years) {
  return Math.trunc(years * monthsInYear);
}

// ../../../../../../tmp/date-fns-jalali/fp/yearsToMonths.mjs
var yearsToMonths3 = convertToFP(yearsToMonths, 1);
// ../../../../../../tmp/date-fns-jalali/yearsToQuarters.mjs
function yearsToQuarters(years) {
  return Math.trunc(years * quartersInYear);
}

// ../../../../../../tmp/date-fns-jalali/fp/yearsToQuarters.mjs
var yearsToQuarters3 = convertToFP(yearsToQuarters, 1);
// ../../../../../../tmp/date-fns-jalali/fp/cdn.js
window.dateFns = {
  ...window.dateFns,
  fp: exports_fp
};

//# debugId=84A9E97B3DF17D2664756e2164756e21
 })();